import lang from "./lang.js";
//菜单数据结构
export const navbar = payload=>{
  const _lang = payload.lang,
    arr = [
    {
      id:"home",
      name:lang[_lang].home,
      link:`/${_lang}/home`
    },
    {
      id:"research",
      name:lang[_lang].research,
      link:`/${_lang}/research`,
      child:[
        {
          id:"dataCenter",
          name:lang[_lang].dataCenter,
          link:`/${_lang}/research/dataCenter`,
          child:[
            {
              id:"blockchain",
              name:lang[_lang].blockchain,
              link:`/${_lang}/research/dataCenter/blockchain`,
            },
            {
              id:"meteorological",
              name:lang[_lang].meteorological,
              link:`/${_lang}/research/dataCenter/meteorological`,
            },
            {
              id:"interOfThing",
              name:lang[_lang].interOfThing,
              link:`/${_lang}/research/dataCenter/interOfThing`,
            },
            {
              id:"traffic",
              name:lang[_lang].traffic,
              link:`/${_lang}/research/dataCenter/traffic`,
            }
          ]
        },
        {
          id:"drive",
          name:lang[_lang].drive,
          link:`/${_lang}/research/drive`,
          child:[
            {
              id:"znjsBigData",
              name:lang[_lang].znjsBigData,
              link:`/${_lang}/research/drive/znjsBigData`
            },
            {
              id:"digitalTwin",
              name:lang[_lang].digitalTwin,
              link:`/${_lang}/research/drive/digitalTwin`
            }
          ]
        },
        {
          id:"artificial",
          name:lang[_lang].artificial,
          link:`/${_lang}/research/artificial`,
          child:[
            {
              id:"medicalCare",
              name:lang[_lang].medicalCare,
              link:`/${_lang}/research/artificial/medicalCare`
            }
          ]
        },
        {
          id:"perception",
          name:lang[_lang].perception,
          link:`/${_lang}/research/perception`,
          child:[
            // {
            //   id:"intelligence",
            //   name:lang[_lang].intelligence,
            //   link:`/${_lang}/research/perception/intelligence`
            // }
          ]
        }
      ]
    },
    // {
    //   id:"forward",
    //   name:lang[_lang].forward,
    //   link:`/${_lang}/forward`,
    //   child:[
    //     {
    //       id:"dataReport",
    //       name:lang[_lang].dataReport,
    //       link:`/${_lang}/forward/dataReport`
    //     },
    //     {
    //       id:"achievements",
    //       name:lang[_lang].achievements,
    //       link:`/${_lang}/forward/achievements`,
    //       child:[
    //         {
    //           id:"patent",
    //           name:lang[_lang].patent,
    //           link:`/${_lang}/forward/achievements/patent`
    //         },
    //         {
    //           id:"copyright",
    //           name:lang[_lang].copyright,
    //           link:`/${_lang}/forward/achievements/copyright`
    //         },
    //         {
    //           id:"paper",
    //           name:lang[_lang].patent,
    //           link:`/${_lang}/forward/achievements/patent`
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      id:"product",
      name:lang[_lang].product,
      link:`/${_lang}/product`,
      child:[
        {
          id:"smartTransportation",
          name:lang[_lang].smartTransportation,
          link:`/${_lang}/product/smartTransportation`
        },
        {
          id:"smartPark",
          name:lang[_lang].smartPark,
          link:`/${_lang}/product/smartPark`
        },
        {
          id:"cityService",
          name:lang[_lang].cityService,
          link:`/${_lang}/product/cityService`
        }
      ]
    },
    {
      id:"news",
      name:lang[_lang].news,
      link:`/${_lang}/news`,
      child_cn:[
        {
          id:"salon",
          name:lang[_lang].salon,
          link:`/${_lang}/news/salon`,
          child:[
            {
              id:"salon2020",
              name:lang[_lang].salon2020,
              link:`/${_lang}/news/salon/content/2`
            },
            {
              id:"block_chain",
              name:lang[_lang].block_chain,
              link:`/${_lang}/news/salon/content/1`
            }
          ]
        },
        {
          id:"forum",
          name:lang[_lang].forum,
          link:`/${_lang}/news/forum`,
          child:[
            {
              id:"forum2019",
              name:lang[_lang].forum2019,
              link:`/${_lang}/news/forum/content/1`
            },
            {
              id:"cs2019",
              name:lang[_lang].cs2019,
              link:`/${_lang}/news/forum/content/2`
            },
            {
              id:"forumcs2018",
              name:lang[_lang].forum2018,
              link:`/${_lang}/news/forum/content/3`
            },
            
          ]
        },
        {
          id:"communication",
          name:lang[_lang].communication,
          link:`/${_lang}/news/communication`
        }
      ],
      child_en:[
        {
          id:"salon",
          name:lang[_lang].salon,
          link:`/${_lang}/news/salon`,
          child:[
            {
              id:"salon2020",
              name:lang[_lang].salon2020,
              link:`/${_lang}/news/salon/2`
            },
            {
              id:"block_chain",
              name:lang[_lang].block_chain,
              link:`/${_lang}/news/salon/1`
            }
          ]
        },
        {
          id:"forum",
          name:lang[_lang].forum,
          link:`/${_lang}/news/forum`,
          child:[
            {
              id:"2019 Forum and Contest",
              name:lang[_lang].forum2019,
              link:`/${_lang}/news/forum/2`
            },
            {
              id:"2018 Forum and Contest",
              name:lang[_lang].forum2018,
              link:`/${_lang}/news/forum/1`
            },
            
          ]
        },
        {
          id:"communication",
          name:lang[_lang].communication,
          link:`/${_lang}/news/communication`
        }
      ]
    },
    {
      id:"about",
      name:lang[_lang].about,
      link:`/${_lang}/about`,
      child:[
        {
          id:"brief",
          name:lang[_lang].brief,
          link:`/${_lang}/about/brief`
        },
        {
          id:"introduce",
          name:lang[_lang].introduce,
          link:`/${_lang}/about/introduce`
        },
        {
          id:"contact",
          name:lang[_lang].contact,
          link:`/${_lang}/about/contact`
        }
      ]
    },
    {
      id:"join",
      name:lang[_lang].join,
      link:`/${_lang}/join`,
      child:[]
     //  child:[
     //    {
          // id:"technology",
     //      name:lang[_lang].technology,
     //      link:`/${_lang}/`,
     //      child:[
     //        {
          //     id:"d1",
     //          name:lang[_lang].d1,
     //          link:`/${_lang}/`
     //        },
     //        {
          //     id:"home",
     //          name:lang[_lang].t1,
     //          link:`/${_lang}/`
     //        },
     //        {
          //     id:"b1",
     //          name:lang[_lang].b1,
     //          link:`/${_lang}/`
     //        },
     //        {
          //     id:"home",
     //          name:lang[_lang].b2,
     //          link:`/${_lang}/`
     //        }
     //      ]
     //    },
     //    {
          // id:"administration",
     //      name:lang[_lang].administration,
     //      link:`/${_lang}/`,
     //      child:[
     //        {
          //     id:"c1",
     //          name:lang[_lang].c1,
     //          link:`/${_lang}/`
     //        },
     //        {
          //     id:"d1",
     //          name:lang[_lang].d1,
     //          link:`/${_lang}/`
     //        },
     //        {
          //     id:"b",
     //          name:lang[_lang].b,
     //          link:`/${_lang}/`
     //        }
     //      ]
     //    }
     //  ]
    },
    {
      name:'lang'
    },
  ];
  if(_lang == 'en') {
    arr[3].child = arr[3].child_en
    arr.unshift({
        name:'logo'
      })
  } else {
    arr[3].child = arr[3].child_cn
    arr.splice(3,0,{
      name:'logo'
    })
  }
  return arr;
};

//首页数据
export const homeData = {
  "zh-CN":{
    "e_center":[
      {
        title:"大数据研究中心",
        cover:require('./assets/img/index_kyzx_dsj.png'),
        icon:require('./assets/img/index_keyan_icon_dashuju.png'),
        active:"active",
        link:"/zh-CN/research/dataCenter",
        list:[
          "区块链与大数据实验室",
          "时空大数据与人工智能实验室",
          "物联网与大数据实验室",
          "交通大数据分析及应用实验室"
        ]
      },
      {
        title:"智能驾驶研究中心",
        cover:require('./assets/img/index_kyzx_znjs.png'),
        icon:require('./assets/img/index_keyan_icon_jiashi.png'),
        active:"",
        link:"/zh-CN/research/drive",
        list:[
          "智能驾驶与大数据实验室",
          "数字孪生实验室"
        ]
      },
      {
        title:"人工智能研究中心",
        cover:require('./assets/img/index_kyzx_rgzn.png'),
        icon:require('./assets/img/index_keyan_icon_ganzhi.png'),
        active:"",
        link:"/zh-CN/research/artificial",
        list:["医疗大数据与人工智能实验室"]
      },
      {
        title:"智能感知研究中心（筹）",
        cover:require('./assets/img/index_kyzx_zngz.png'),
        icon:require('./assets/img/index_keyan_icon_shou.png'),
        active:"",
        link:"/zh-CN/research/perception",
        list:[]
      }
    ],
    about:[
      "珠海市岭南大数据研究院是一家由珠海高新区管委会发起设立的非盈利新型科研机构，成立于2018年4月。",
      "研究院与国内外知名高校合作，通过引进大数据和人工智能领域顶尖人才，致力于开展政府各部门数据、运营商数据及园区企业数据的融合研究、数据安全研究，打造城市级大数据体验场景。在政府..."
    ],
    product:[
      {
        icon:require('./assets/img/index_yewu_icon_jiaot.png'),
        active_icon:require('./assets/img/index_yewu_icon_jiaoth.png'),
        bg:require('./assets/img/index_yewu_zhjt.png'),
        title:"智慧交通",
        desc:"城市公交线路优化",
        active:"",
        link:"/zh-CN/product/smartTransportation"
      },
      {
        icon:require('./assets/img/index_yewu_icon_yuanq.png'),
        active_icon:require('./assets/img/index_yewu_icon_yuanqh.png'),
        bg:require('./assets/img/index_yewu_zhyq.png'),
        title:"智慧园区",
        desc:"数据集成建模功能",
        active:"",
        link:"/zh-CN/product/smartPark"
      },
      {
        icon:require('./assets/img/index_yewu_icon_chengs.png'),
        active_icon:require('./assets/img/index_yewu_icon_chengsh.png'),
        bg:require('./assets/img/index_yewu_zhcs.png'),
        title:"智慧城市",
        desc:"市政、能源等整体化解决方案",
        active:"",
        link:"/zh-CN/product/cityService"
      }
    ],
    news:[
      {
        title:"喜报：我院一项成果获得2021地理信息科技进步奖一等奖",
        desc:"日前，中国地理信息产业协会公布了2021地理信息科技进步奖评选结果，我院联合北京大学深圳研究生院的一项成果喜获一等奖。",
        thumb:require('./assets/img/news/technology/technology1.png'),
        datetime:"2021-11-30",
        url:"/zh-CN/news/communication/content/5",
        active:"active"
      },
      {
        title:"我院正式加入广东省5G行业应用产业技术创新联盟，携手迈进5G未来",
        desc:"我院正式加入广东省5G行业应用产业技术创新联盟，携手迈进5G未来",
        thumb:require('./assets/img/news/2021/5g.jpg'),
        datetime:"2021-11-23",
        url:"/zh-CN/news/communication/content/4",
        active:"active"
      },
      {
        title:"2020科研沙龙系列",
        desc:"新基建浪潮下，智慧园区的机遇与挑战",
        thumb:require('./assets/dataimg/new-salon-2thumb.jpg'),
        datetime:"2020-08-25",
        url:"/zh-CN/news/salon/content/2",
        active:"active"
      },
      {
        title:"珠海市区块链与信息安全国际研讨会",
        desc:"11月22日，珠海市区块链与信息安全国际研讨会在珠海高新区隆重举行，会议由珠海市岭南大数据研究院主办。",
        thumb:require('./assets/img/02kyzx_rgzn.png'),
        datetime:"2019-11-22",
        url:"/zh-CN/news/salon/content/1",
        active:"active"
      },
      {
        title:"2019岭南大数据国际论坛",
        desc:"以人工智能为代表的全球新一轮科技创新正在步入大国竞争时代，其中5G技术更是各国争夺的焦点。时局之下，风口之上，国家工信部为推动5G技术的商用及产业发展，发起了围绕5G应用场景的优秀创新创业项目征集赛事系列。",
        thumb:require('./assets/img/news001.png'),
        datetime:"2019-09-07",
        url:"/zh-CN/news/forum/content/1",
        active:"active"
      },
      {
        title:"工信部第二届“绽放杯”5G应用征集大赛之珠海智慧城市专题赛",
        desc:"以人工智能为代表的全球新一轮科技创新正在步入大国竞争时代，其中5G技术更是各国争夺的焦点。时局之下，风口之上，国家工信部为推动5G技术的商用及产业发展，发起了围绕5G应用场景的优秀创新创业项目征集赛事系列。",
        thumb:require('./assets/img/02kyzx_rgzn.png'),
        datetime:"2019-09-06",
        url:"/zh-CN/news/forum/content/2",
        active:""
      },
      {
        title:"人工智能“芯”科技国际学术交流会院士讲坛",
        desc:"7月29日上午，2019人工智能“芯”科技国际学术交流会在珠海市成功着陆。",
        thumb:require('./assets/img/02kyzx_rgzn.png'),
        datetime:"2019-07-29",
        url:"/zh-CN/news/communication/content/3",
        active:""
      },
      // {
      //   title:"2018岭南大数据国际论坛暨创新创业大赛",
      //   desc:"贯彻国家“国家大数据战略”和“创新驱动发展战略”，响应加快数字化中国建设的战略布局，在珠海高新区管委会指导下，珠海市岭南大数据研究院于2018年9月至12月筹备举办了 “2018岭南大数据国际论坛暨创新创业大赛”系列活动，",
      //   thumb:require('./assets/img/news001.png'),
      //   datetime:"2018-12-08",
      //   url:"/zh-CN/news/forum/content/3",
      //   active:"active"
      // },
    ]
  },
  "en":{
    "e_center":[
      {
        title:"Big Data",
        cover:require('./assets/img/index_kyzx_dsj.png'),
        icon:require('./assets/img/index_keyan_icon_dashuju.png'),
        active:"active",
        link:"/en/research/dataCenter",
        list:["Blockchain and Big Data Lab","Spatiotemporal Big Data and AI Lab","IoT and Big Data Lab","Traffic Big Data Analysis and Application Lab"]
      },
      {
        title:"Autonomous Driving",
        cover:require('./assets/img/index_kyzx_znjs.png'),
        icon:require('./assets/img/index_keyan_icon_jiashi.png'),
        active:"",
        link:"/en/research/drive",
        list:[
          "Autonomous Driving and Big Data Lab",
          "Digital Twin Lab"
        ]
      },
      {
        title:"Artificial Intelligence",
        cover:require('./assets/img/index_kyzx_rgzn.png'),
        icon:require('./assets/img/index_keyan_icon_ganzhi.png'),
        active:"",
        link:"/en/research/artificial",
        list:["Medical Big Data and AI Lab"]
      },
      {
        title:"Intelligence Recognition(coming soon)",
        cover:require('./assets/img/index_kyzx_zngz.png'),
        icon:require('./assets/img/index_keyan_icon_shou.png'),
        active:"",
        link:"/en/research/perception",
        list:[]
      }
    ],
    about:[
      "Zhuhai Big Data Institute (BDI) was founded in April 2018 as a non-profit research organization and sponsored by Zhuhai Government. BDI for research on innovation and science has brought worldwide famous scientists, researchers and top talents from different higher education institutions and organizations in Artificial Intelligence, Big Data areas. In August 2019, we have...",
    ],
    product:[
      {
        icon:require('./assets/img/index_yewu_icon_jiaot.png'),
        active_icon:require('./assets/img/index_yewu_icon_jiaoth.png'),
        bg:require('./assets/img/index_yewu_zhjt.png'),
        title:"Intelligence",
        desc:"Public Transportation Network Optimization",
        active:"",
        link:"/en/product/smartTransportation"
      },
      {
        icon:require('./assets/img/index_yewu_icon_yuanq.png'),
        active_icon:require('./assets/img/index_yewu_icon_yuanqh.png'),
        bg:require('./assets/img/index_yewu_zhyq.png'),
        title:"Smart Park",
        desc:"Data Driven Modeling",
        active:"",
        link:"/en/product/smartPark"
      },
      {
        icon:require('./assets/img/index_yewu_icon_chengs.png'),
        active_icon:require('./assets/img/index_yewu_icon_chengsh.png'),
        bg:require('./assets/img/index_yewu_zhcs.png'),
        title:"Smart City",
        desc:"Integrated Solutions for Municipal Administration and Energy",
        active:"",
        link:"/en/product/cityService"
      }
    ],
    news:[
      {
        title:"Research Workshop Series 2020",
        desc:"On August 25, 2020, under the guidance of the Zhuhai National Hi-Tech Industrial Development District and hosted by Lingnan Big Data Research Institute, the Research Workshop Series 2020  was held. ",
        thumb:require('./assets/dataimg/new-salon-2thumb_en.png'),
        datetime:"2020-08-25",
        url:"/en/news/salon/2",
        active:"active"
      },
      {
        title:"Blockchain Seminar",
        desc:"On November 22, 2019,  Lingnan Big Data Research Institute hosted the Zhuhai International Seminar on Blockchain and Information Security. ",
        thumb:require('./assets/img/02kyzx_rgzn.png'),
        datetime:"2019-11-22",
        url:"/en/news/salon/1",
        active:"active"
      },
      {
        title:"2019 Forum and Contest",
        desc:"From September 6th to 7th, 2019, the 5G Application Contest of the MIIT-Zhuhai Smart City and the 2nd Lingnan Big Data International Forum were held.",
        thumb:require('./assets/img/news001.png'),
        datetime:"2019-09-07",
        url:"/en/news/forum/2",
        active:"active"
      },
      // {
      //   title:"2nd MIIT \"Zhanfang\" Cup 5G application challenge-Zhuhai ",
      //   desc:"以人工智能为代表的全球新一轮科技创新正在步入大国竞争时代，其中5G技术更是各国争夺的焦点。时局之下，风口之上，国家工信部为推动5G技术的商用及产业发展，发起了围绕5G应用场景的优秀创新创业项目征集赛事系列。",
      //   thumb:require('./assets/img/02kyzx_rgzn.png'),
      //   datetime:"2019-09-06",
      //   url:"/en/news/forum/content/2",
      //   active:""
      // },
      {
        title:"AI Summer Course",
        desc:"From July 29 to August 2, 2019, Summer Course in Artificial Intelligence was held in Zhuhai for the first time.",
        thumb:require('./assets/img/02kyzx_rgzn.png'),
        datetime:"2019-07-29",
        url:"/en/news/communication/1",
        active:""
      },
      {
        title:"2018 Forum and Contest",
        desc:'On December 8, 2018, Lingnan Big Data Research Institute organized the "2018 Lingnan Big Data International Forum and Innovation and Entrepreneurship Competition". ',
        thumb:require('./assets/img/news001.png'),
        datetime:"2018-12-08",
        url:"/en/news/forum/1",
        active:"active"
      },
    ]
  }
};

//科研中心数据
export const researchData = {
  "zh-CN":{
    drive:{
      imgUrl:require('./assets/img/02kyzx_zinengjias.png'),
      feildDesc:"智能驾驶研究中心致力于建设粤港澳大湾区智能驾驶系统科创平台，为产业界提供成熟的智能驾驶系统整体解决方案。主要围绕无人驾驶感知、导航、规划决策、深度学习、数据集等开展理论与应用研究，实现智能驾驶技术和产品等方面的研发、应用和推广。智能驾驶研究中心下设智能驾驶与大数据实验室、数字孪生实验室。",
      znjsBigData:{
        thumb:require('./assets/img/sys_jiashi.png'),
        title:"智能驾驶与大数据实验室",
        content:[
          {
            title: "实验室简介",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室围绕与智能驾驶相关的大数据展开研究，旨在打造服务于智能驾驶研究者/从业者的不同类型开源数据集，并基于这些数据集展开智能感知、智能控制和智能决策等方向的前沿研究。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">多传感器标定；人脸隐私保护；半自动/自动数据标注；基于数据集的仿真系统。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0 0 10px 0;text-indent:2em;\">基于多传感器的智能驾驶数据集建设。项目来源于“国家重点研发计划智能机器人专项”，分别采集并制作基于激光雷达点云序列的大场景数据集，基于视频的动态场景数据集，以及基于多传感器融合的场景数据集。</p>"
          }
        ]
      },
      digitalTwin:{
        thumb:require('./assets/img/sys_luansheng.png'),
        title:"数字孪生实验室",
        content:[
          {
            title: "实验室简介",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室主要从事快速数据采集和模型建立、多维可视化、预测模型推演、海量点云数据压缩和提取等关键技术研发与应用，助力政府和企业智能化升级。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">智慧园区数字孪生前沿研究；海量数据压缩和快速提取技术研究；数据可视化与管理决策支持系统研究。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">智慧园区示范。为工业园区、科创园区提供三维引擎和测绘方案,建立3D可视化系统，推进园区的更高效管理。</p>"
          }
        ]
      }
    },
    artificial:{
      imgUrl:require('./assets/img/02kyzx_rgzn.png'),
      feildDesc:"人工智能研究中心面向新一代人工智能技术和应用的研究前沿，旨在推进人工智能平台底层软硬件技术及与不同学科的交叉方向研究，培育拥有自主知识产权的人工智能生态系统。",
      medicalCare:{
        thumb:require('./assets/img/sys_yiliao.png'),
        title:"医疗大数据与人工智能实验室",
        content:[
          {
            title: "实验室简介",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室旨在充分发挥大数据和人工智能研发能力，结合病理诊断技术、海量医疗数据及场景的优势，共同推进在医疗大数据分析与挖掘、自动辅助诊断技术、医疗影像人工智能算法的研究，加速人工智能在实际业务场景中落地应用。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">基于多模态数据融合处理的新生儿疼痛评价方法研究；"+
            "多源医疗健康数据的智能分析工具及应用系统研究；"+
            "基于机器学习的智能医学健康信息处理与分析；"+
            "其它大数据与人工智能在医疗领域共性关键技术研究。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">基于多模态数据融合处理的新生儿疼痛评价方法研究。本项目应用计算机视觉、模式识别和语音识别技术，对新生儿面部表情、声音、身体运动和生命体征等多模态数据进行融合分析与挖掘，提出一种基于行为和生理疼痛指标的自动化测量和评估新生儿疼痛的方法，帮助医护人员了解新生儿需求，采取及时和适当的干预措施。</p>"
          }
        ]
      }
    },
    perception:{
      imgUrl:require('./assets/img/02kyzx_zngz.png'),
      // feildDesc:"智能感知研究中心致力于研发先进的智能感知技术，围绕从新型传感芯片和新型传感器技术，建立智能传感创新技术的应用研究平台，重点研发技术主要包括：智能传感器技术、无线感知网络、智能感知技术，为大数据、人工智能等新兴领域提供技术支持。智能感知研究领域目前下设智能互联与计算联合研究实验室。",
      feildDesc:"筹备中，敬请期待...",
      intelligence:{
        thumb:require('./assets/img/sys_yiliao.png'),
        title:"...",
        content:[
          {
            title:"",
            content:"资料筹备中..."
          }
        ]
      }
    },
    dataCenter:{
      imgUrl:require('./assets/img/02kyzx_dashuju.png'),
      feildDesc:"大数据研究中心融合移动运营商大数据、政务大数据、互联网大数据资源优势，围绕珠海市及粤港澳大湾区的数字经济产业应用需求，开展大数据应用创新、多源数据融合及数据计算加速等相关方面的研究。大数据研究中心下设物联网与大数据实验室、区块链与大数据实验室、时空大数据与人工智能实验室、交通大数据分析及应用实验室。",
      interOfThing:{
        thumb:require('./assets/img/sys_wulianwang.png'),
        title:"物联网与大数据实验室",
        content:[
          {
            title:"实验室简介",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室围绕物联网和大数据融合发展方向，开展相关理论、技术和应用创新研究，在智慧城市、智慧旅游、智能制造、智慧农业、智慧医疗、工业互联网、智慧能源等应用领域开展技术应用及产业化合作，促进物联网、大数据、云计算、5G、人工智能等新一代信息技术与实体经济的深度融合。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">群智感知网络中的用户行为优化；移动泛在感知上的旅游计算；5G无线资源管理与系统性能评估；基于边缘计算的超低功耗移动定位。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">可控式与参与式感知网络的联合设计及其在智慧旅游中的应用。项目来源于“国家重点研发计划项目（政府间国际科技创新合作重点专项）”，针对智慧旅游中信息感知与智慧规划两个关键问题，通过可控式感知网络和参与式感知网络的联合设计实时、准确的全局旅游信息估计；并通过信息深度挖掘，结合游客的个人偏好，为游客制定智慧化、个性化的旅游方案。</p>"
          }
        ]
      },
      blockchain:{
        thumb:require('./assets/img/sys_qukuail.png'),
        title:"区块链与大数据实验室",
        content:[
          {
            title:"实验室简介",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室开展区块链技术原理与底层架构、基于区块链技术的大数据应用平台研究，推广区块链技术在金融、电子政务、智慧城市、物联网等领域的应用。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">区块链基础架构、数字身份、密码协议、信息安全工程、隐私保护、自动化监管科技、安全代码检测等。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">监管科技上链：研究基于区块链内置的智能化监管技术，将监管科技作为区块链的内置技术来保护区块链的发展，而不是政府从外部对区块链监管。</p>"+
            "<p style=\"margin:0;text-indent:2em;\">科技金融上链：基于区块链的可信技术，通过分布式账本，多方数据联合交叉验证，打造基于区块链技术的多方可信数据流的无抵押贷款解决方案。</p>"+
            "<p style=\"margin:0;text-indent:2em;\">建设工程上链：建立建设工程项目全过程管理平台，为工程项目构建完整的信用生态系统，运用区块链、大数据等前沿科技技术，协助甲方做项目全生命周期的管理，让项目责任可追溯，让项目管理透明化，让过程变得更公平公正。</p>"
          }
        ]
      },
      traffic:{
        thumb:require('./assets/img/sys_jiaotong.png'),
        title:"交通大数据分析及应用实验室",
        content:[
          {
            title:"实验室简介",
            content: "<p style=\"margin:0;text-indent:2em;\">实验室围绕城市智慧交通建设的需求，改善和提高城市公共交通系统的系统化、科学化、智慧化管理与服务水平，致力于城市公共交通多源大数据分析应用技术研发，推动并促进相关技术的产业化合作。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">基于信令数据的城市居民出行行为的基础分析研究；城市多源交通大数据与公交运营的基础分析研究；基于城市多源交通大数据的公交设施及资源规划研究。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">公交线网仿真系统：基于大量的多模式交通流分析结果，揭示公交车流的运行规律和乘客的出行规律，通过实时的人、车数据推演系统的运行情况，对可能出现的突发情况制定应急方案，并评估。该研究将为城市大规模公交优化提供技术支撑。</p>"+
            "<p style=\"margin:0;text-indent:2em;\">公交异常事件调度系统：以公交线网仿真系统为基础，针对公交运营中产生的异常事件，开发解决此问题的调度系统，通过调整时刻表、借调车辆、调整运行方案等手段，为公交调度人员提供辅助决策方案。</p>"+
            "<p style=\"margin:0;text-indent:2em;\">公交线网优化分析研究：基于移动信令位置数据和公交车流、人流数据，通过仿真方法对实施方案的优化效果进行评估，为公交线网的进一步优化提升提供决策支持。</p>"
          }
        ]
      },
      meteorological:{
        thumb:require('./assets/img/sys_shikong.png'),
        title:"时空大数据与人工智能实验室",
        content:[
          {
            title:"实验室简介",
            content: "<p style=\"margin:0;text-indent:2em;\">实验室以时空大数据与人工智能为研究方向，在新一代时空数据模型和相关的支撑技术上取得基础理论或核心技术的突破，推动空间感知技术的发展。实验室基于多维度时空数据以及模型算法等核心优势，为不同行业提供高价值数据应用方案，同时服务于政府部门的智慧城市建设。</p>"
          },
          {
            title:"研究方向",
            content:"<p style=\"margin:0;text-indent:2em;\">实验室开展时空大数据模型及人工智能算法前沿研究，智慧城市、数字政府、金融保险等重点领域时空大数据及人工智能应用技术研究，面向重点领域的专题信息服务产品研发，系统维护以及服务平台运营。</p>"
          },
          {
            title:"在研项目",
            content:"<p style=\"margin:0;text-indent:2em;\">城市内涝监测及保险服务平台。项目利用现有的智慧城市信息化基础设施，建设城市内涝监测及预警系统；同时基于内涝灾害预警及灾害监测服务系统，围绕保险公司车辆保险服务产品的业务需求，进行车辆保险服务相关系统设计及关键技术研发。</p>"
          }
        ]
      }
    }
  },
  "en":{
    drive:{
      imgUrl:require('./assets/img/02kyzx_zinengjias.png'),
      feildDesc:"The Autonomous Driving Research Center is  dedicated to building a technology innovation platform for autonomous driving systems in the Guangdong-Hong Kong-Macao Greater Bay Area, to provide a mature autonomous driving system solution. It mainly focuses on carrying out theoretical and applied research based on auto-driving , navigation, planning, decision-making, deep learning, data sets, etc.，while realizing the research development, application, and promotion of autonomous driving technology and products at the same time.",
      znjsBigData:{
        thumb:require('./assets/img/sys_jiashi.png'),
        title:"Autonomous Driving and Big Data Lab",
        content:[
          {
            title: "Introduction",
            content:"<p style=\"margin:0;text-indent:2em;\">The lab focuses on big data research related to autonomous driving, aiming to create different types of open source data sets for researchers/practitioners. Based on these data sets, the lab will carry out cutting-edge research in intelligent perception,  control and decision-making, etc.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">Multi-sensor calibration;Face privacy protection;Semi-automatic/automatic data labeling;Simulation system based on data set.</p>"
          },
          {
            title:"Research Project",
            content:"<p style=\"margin:0 0 10px 0;text-indent:2em;\">Autonomous driving data set construction based on multi-sensor.The project is originated from the \"National Key Research and Development Project: Intelligent Robot Project\", which collected and produced large scene data sets based on lidar point cloud sequences, video-based dynamic scene data , and data sets based on multi-sensor data fusion.</p>"
          }
        ]
      },
      digitalTwin:{
        thumb:require('./assets/img/sys_luansheng.png'),
        title:"Digital Twin Lab",
        content:[
          {
            title: "Introduction",
            content:"<p style=\"margin:0;text-indent:2em;\">The lab is mainly engaged in the development and application of key technologies such as rapid data collection and model establishment, multi-dimensional data visualization, predictive model deduction, compression and extraction of massive point cloud data, in order to help governments and enterprises to upgrade their intelligence.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">Frontier research on digital twins in smart parks;Research on massive data compression and rapid extraction technology;Research on data visualization and management decision supporting system.</p>"
          },
          {
            title:"Research Project",
            content:"<p style=\"margin:0;text-indent:2em;\">Smart park demonstration.The project provides three-dimensional engines, several surveying solutions, and establish a 3D visualization system to promote more efficient management for industrial parks and science technology parks.</p>"
          }
        ]
      }
    },
    artificial:{
      imgUrl:require('./assets/img/02kyzx_rgzn.png'),
      feildDesc:"Aiming at the frontiers of the new generation of artificial intelligence technology and applications, the Artificial Intelligence Research Center aims to promote the research of the underlying software and hardware technologies of the artificial intelligence platform and the cross-direction of different disciplines, and cultivate an artificial intelligence ecosystem with independent intellectual property rights.",
      medicalCare:{
        thumb:require('./assets/img/sys_yiliao.png'),
        title:"Medical Big Data and AI Lab",
        content:[
          {
            title: "Introduction",
            content:"<p style=\"margin:0;text-indent:2em;\">The lab aims at combining big data，AI technology and the advantages of pathological diagnosis technology, massive medical data and scenarios, to promote the research of medical big data analysis and mining, automatic auxiliary diagnosis technology, and medical imaging artificial intelligence algorithms. The lab aims at accelerating the application of AI.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">Research on pain in the newborn  evaluation method based on multi-modal data fusion;"+
            "Research on intelligent analysis tools and application of multi-source medical health data;"+
            "Intelligent medical health information processing and analysis based on machine learning;"+
            "Research on other common critical technologies of big data and artificial intelligence in the medical field.</p>"
          },
          {
            title:"Research Projects",
            content:"<p style=\"margin:0;text-indent:2em;\">Research on evaluation of pain in the newborn, based on multimodal data fusion. This project uses computer vision, pattern and speech recognition to conduct fusion analysis and mining of  facial expressions, voices, body movements and vital signs and other data, and proposes an automated measurement based on behavioral and physiological pain indicators. The method helps medical staffs understand the needs of neonates, and taking timely intervention measures.</p>"
          }
        ]
      }
    },
    perception:{
      imgUrl:require('./assets/img/02kyzx_zngz.png'),
      // feildDesc:"智能感知研究中心致力于研发先进的智能感知技术，围绕从新型传感芯片和新型传感器技术，建立智能传感创新技术的应用研究平台，重点研发技术主要包括：智能传感器技术、无线感知网络、智能感知技术，为大数据、人工智能等新兴领域提供技术支持。智能感知研究领域目前下设智能互联与计算联合研究实验室。",
      feildDesc:"Coming soon...",
      intelligence:{
        thumb:require('./assets/img/sys_yiliao.png'),
        title:"...",
        content:[
          {
            title:"",
            content:"Coming soon..."
          }
        ]
      }
    },
    dataCenter:{
      imgUrl:require('./assets/img/02kyzx_dashuju.png'),
      feildDesc:"Integrating data from mobile operators, government and the Internet, the Big Data Research Center focuses on the application of digital economy in Zhuhai and the Greater Bay Area. The Center carries out researches on big data innovative applications innovation, multi-source data fusion and data compute acceleration. The Big Data Research Center consists of IoT and Big Data Lab, Blockchain and Big Data Lab, Spatiotemporal Big Data and AI Lab, as well as Traffic Big Data Analysis and Application Lab.",
      interOfThing:{
        thumb:require('./assets/img/sys_wulianwang.png'),
        title:"IoT and Big Data Lab",
        content:[
          {
            title:"Introduction",
            content:"<p style=\"margin:0;text-indent:2em;\">The laboratory carries out relevant researches on theories, techniques and innovative applications  in fields of Internet of things and big data fusion. The lab launches technology application and industrial cooperation in smart cities, smart tourism, smart manufacturing, smart agriculture, smart healthcare, industrial internet and smart energy, promoting the integration between new information technologies such as IoT, big data, cloud computing, 5G, AI, and the real economy.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">User behavior optimization  based on Crowd-Sensing network；Mobile Ubiquitous  perception computing  on tourism；5G wireless resource management and system performance evaluation；Ultra-low power consumption mobile positioning based on edge computing.</p>"
          },
          {
            title:"Research Projects",
            content:"<p style=\"margin:0;text-indent:2em;\">Joint Design of controllable & participative perceptive  networks and its application in intelligent tourism. The project is based on the National Key Research and Development Project (The key project of international cooperation in science, technology and innovation between governments) , aiming at the two key issues of information perception and intelligent planning in intelligent tourism. Through the joint design of controllable perceptive network and participatory perception network, the real-time, accurate global tourism information estimation can be realized.  Through data mining, the project develops intelligent and customized  travel plans for different tourists.</p>"
          }
        ]
      },
      blockchain:{
        thumb:require('./assets/img/sys_qukuail.png'),
        title:"Blockchain and Big Data Lab",
        content:[
          {
            title:"Introduction",
            content:"<p style=\"margin:0;text-indent:2em;\">The laboratory aims at studying theory, fundamental concept of blockchain technology and promoting its application platform in e-commerce, e-government, smart city and IoT. </p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">Blockchain infrastructure, digital identity, cryptographic protocols, information security engineering, privacy protection, automated supervision technology, security code detection, etc.</p>"
          },
          {
            title:"Research Projects",
            content:"<p style=\"margin:0;text-indent:2em;\">On-Chain regulatory: Based on the built-in intelligent supervision technology of blockchain, rather than the government supervising the blockchain externally.</p>"+
            "<p style=\"margin:0;text-indent:2em;\">On-Chain finance: Based on blockchain-based trusted technology, through distributed ledger and cross validation, an unsecured loan solution based on blockchain technology with multi-party trusted data flow is created.</p>"+
            "<p style=\"margin:0;text-indent:2em;\">On-Chain construction: Making use of  blockchain and big data, the research aims to establish a management platform for construction projects and thus to complete the credit system. It helps the first party to manage the life cycle of the project.</p>"
          }
        ]
      },
      traffic:{
        thumb:require('./assets/img/sys_jiaotong.png'),
        title:"Traffic Big Data Analysis and Application Lab",
        content:[
          {
            title:"Introduction",
            content: "<p style=\"margin:0;text-indent:2em;\">The laboratory is dedicated to the research and development of multi-source big data analysis and application technology for urban public transport, improving the systematic, scientific and intelligent management and the service level of urban public transport system, to  facilitate the industrialization  of related technologies.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">The basic analysis research of urban residents’ travel behavior based on signaling data; Basic Analysis Research of urban multi-source traffic data and Public Transport Operation; Research of public transport facilities and resource planning based on urban multi-source traffic data.</p>"
          },
          {
            title:"Research Projects",
            content:"<p style=\"margin:0;text-indent:2em;\">Based on a large number of  traffic flow analysis results, the Bus Network Simulation System reveals regulations of bus flow and passenger travel patterns.Through real-time data of people and vehicles, the system develops emergency plans for possible contingencies.The study will provide technical support for urban transport optimization.</p>"+
            "<p style=\"margin:0;text-indent:2em;\">Based on the bus network simulation system, the Management Systerm for Bus Unusual Events aims at solving the  exceptions in bus operations.</p>"+
            "<p style=\"margin:0;text-indent:2em;\">Based on the mobile signaling data, bus flow and passenger flow data, the analysis on bus network use simulation to evaluate the optimization, providing support in decision-making.</p>"
          }
        ]
      },
      meteorological:{
        thumb:require('./assets/img/sys_shikong.png'),
        title:"Spatiotemporal Big Data and AI Lab",
        content:[
          {
            title:"Introduction",
            content: "<p style=\"margin:0;text-indent:2em;\">BDI's Spatiotemporal Big Data and AI Lab has achieved breakthroughs in spatiotemporal data models and related supporting technologies. Based on our core advantages such as multi-dimensional spatiotemporal data and model algorithms, the lab provides effective data application solutions for different industries, and at the same time it serves the government in the process of building smart cities.</p>"
          },
          {
            title:"Research Focus",
            content:"<p style=\"margin:0;text-indent:2em;\">The lab conducts cutting-edge research on spatiotemporal big data models and AI algorithms, applied in key fields such as smart cities, digital government, finance and insurance. Research and development of information service products, system maintenance and service platforms operations are also included.</p>"
          },
          {
            title:"Research Projects",
            content:"<p style=\"margin:0;text-indent:2em;\">Urban rainstorm waterlogging monitoring and insurance service platform. The project uses the existing smart city informatization infrastructure to build an urban waterlogging monitoring and early warning system. We also design insurance service related system for vehicles according to the needs of vehicles insurance companies.</p>"
          }
        ]
      }
    }
  }
};

//前沿观察
export const forward = {
  "zh-CN":{
    dataReport:null,
    achievements:null
    
  },
  "en":{
    dataReport:null,
    achievements:null
    
  }
};

//业务板块数据
export const product = {
  "zh-CN":{
    cityService:{
      img1:require('./assets/img/ywbk_tuc.jpg'),
      icon1:require('./assets/img/ywbk_city.png'),
      text1:"智慧城市服务体系以大数据技术驱动智慧城市的发展，做到“让数据说话，用数据决策”。整合智慧城市各部件所产生的多源异构数据，创新智慧城市大数据应用场景；借助人工智能算法、大数据模型以及多种数据呈现工具，快速将关键信息提供给决策者，支撑智慧城市的规划、建设和运营。",
      data1:{
        thumb:require('./assets/dataimg/ywbk18.jpg')
      },
      serveic:[
        {
          name:"产品",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"margin-bottom: 100px;\">"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          "数据驾驶舱"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">产品一</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_19.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>统一数据池支撑多渠道呈现</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">数字大屏、手机小程序等多种方式保障用户在任何时候、任何地点都可以即时掌握关心的数据。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_20.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>专有数据模型实现精准预警</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">已提炼22个业务版块、42个图层的政务数据和对应数据模型，可以根据不同的业务需求提供差异化精准预警。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_21.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>智能管道技术快速打通数据</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">直接通过业务系统界面打通数据管道，只需业务人员参与，无需源系统开发商支持，平均每天可对接4个接口。</p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div style=\"margin-bottom: 100px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk20.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          " 物联网平台服务"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">产品二</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_22.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>支持私有化部署</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">解决政府数据产权问题和物联终端统一管理的问题。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_23.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>南向物联终端解耦</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">提供丰富的接入协议支撑，及灵活的数据模型定义,可以适应更多的协议和更多的厂家。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_24.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>全套物联应用服务</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">提供前期解决方案服务、中期建设支撑服务和后期运营支撑服务，协助管理者把物联网平台用起来。</p>"+
            "</div>"+
          "</div>"+
          
          
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk22.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          " 精准靶向短信服务平台"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">产品三</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_03.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>精准靶向</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">通过GIS地图多种形状选择靶向短信发送区域，提供基于运营商大数据的精准靶向短信能力。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_09.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>多模式支撑</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">平台支持普通短信、靶向短信等多种方式的短信发送。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_15.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>三网合一</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">在一套平台上，支持中国移动、中国电信、中国联通三大运营商的短信发送。</p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk24.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          " 应急信息报送平台"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">产品四</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_04.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>上报内容定制灵活</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">管理员可以根据不同的应急事件和应急预案，快速定制上报内容模板，一键下发到各上报人员移动终端。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_25.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>填报通知智能及时</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">系统可根据对应预案的上报通知规则，自动拨号/短信通知上报人员及时填报信息。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_26.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>汇总数据统计便捷</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">后台依据应急场景智能汇总对应专题的上报数据，快速形成数据报表，为应急指挥提供决策数据支持。</p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk26.jpg')+"\" /></div>"
        },
        {
          name:"服务优势",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div style=\"margin-bottom: 20px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk27.jpg')+"\" /></div>"+
          "<div style=\"margin-bottom: 20px;\">"+
          
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_16.png')+"\" /></div>"+
          "<div style=\"float: left; padding:20px;\"><b>专家资源</b><br />拥有海内外院士、教授等智慧城市领域的高端专家资源，专注于解决智慧城市建设中的规划设计、标准制定、关键技术、核心模型等难点。</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_17.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;\"><b>核心技术</b><br />智能管道技术实现快速、低成本打破“数据孤岛”，解决智慧城市建设中的数据整合问题。</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_18.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;\"><b>联合创新实验室</b><br />大数据联合创新实验室通过整合运用政府、各运营商、企业等多源数据，支撑大数据产品从方案到上线的全生命周期，解决数据应用和创新问题。</div>"+
          "</div>"+
          
          "</div>"
        }
      ]
    },
    smartPark:{
      img1:require('./assets/img/ywbk_tuy.jpg'),
      icon1:require('./assets/img/ywbk_05.png'),
      text1:"智慧园区解决方案面向各类科技园区、产业开发区、产业新城等，以物联管理平台和大数据平台为底座，打造智能化、标准化智慧园区，为园区用户提供优质的服务体验，为园区运营者提供科学的运营服务支撑，为政府提供精确决策依据。",
      data1:{
        thumb:require('./assets/dataimg/ywbk12.jpg')
      },
      serveic:[
        {
          name:"产品功能",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"margin-bottom: 100px; position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu01.jpg')+"\" />"+
          "<div style=\" position: absolute; right:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_12.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>全面感知，集中监控</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">将各智能化系统的信息与功能汇聚到园区物联管理平台进行集中统一监控管理，园区管理人员可以在监控中心客户端或移动客户端实现对各智能化系统的监控和管理。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"margin-bottom: 100px;position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu02.jpg')+"\" />"+
          "<div style=\" position: absolute; left:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_13.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>业务协同，智能联动</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">以园区物联管理平台为中心，通过深度业务集成，在业务层面打通各智能化系统，通过统一的业务功能集成，实现跨系统的协同与联动。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu03.jpg')+"\" />"+
          "<div style=\" position: absolute; right:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_15.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>数据分析，辅助决策</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">通过大数据平台，结合园区物联管理平台数据及其他数据源，按照各业务管理需求及各类可视化图形场景，进行数据挖掘和分析，辅助决策。</p>"+
          "</div>"+
          "</div>"
        },
        {
          name:"产品优势",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div style=\"margin-bottom: 20px; \">"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_09.png')+"\" /></div>"+
          "<div style=\"float: left; padding:20px;\"><b>快速打通数据</b><br />物联管理平台能够快速对接智慧园区智能化子系统，打通系统壁垒，实现数据采集和对智能化系统的控制。</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_10.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;\"><b>多源数据融合</b><br />对接运营商数据、园区数据、网络数据等数据资源，综合分析园区人员、交通、消费等数据，动态分析企业经营情况，指导园区运营决策。</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_11.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;\"><b>标准应用模块</b><br />提供标准化的应用功能，涵盖监控、管理和分析决策，针对不同园区需求和智能化设备建设情况按需配置应用模块。</div>"+
          "</div>"+
          "</div>"+
          "<div style=\"margin-bottom: 20px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk17.jpg')+"\" /></div>"
        }
      ]
    },
    smartTransportation:{
      img1:require('./assets/img/ywbk_tuj.jpg'),
      icon1:require('./assets/img/ywbk_05.png'),
      text1:"充分发挥运营商大数据人口覆盖率高、实时性强、不间断的特征，融合公交、出租车、互联网等多源行业数据，聚焦公共交通领域，形成了以大数据为支撑的专业化、精准化、定制化的公交优化服务。",
      data1:{
        thumb:require('./assets/dataimg/data1.jpg')
      },
      serveic:[
        {
          name:"服务内容",
          icon1:require('./assets/img/ywbk_xiangmu-bai.png'),
          icon2:require('./assets/img/ywbk_xiangmu-hei.png'),
          content:"<p><b>公交优化一体化解决方案：</b>出行需求感知、服务供需匹配、方案优化和运力调度、系统推演和评估、可视化监控等全流程服务。</p>"+
          "<p class=\"text-center\" style=\"margin:30px 0;\"><img style=\"width: 600px;\" src=\""+require('./assets/dataimg/data2.jpg')+"\" /></p>"+
          // "<p><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/data3.jpg')+"\" /></p>"+
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_01.png')+"\" />"+
            "<p style=\"text-align:left; padding: 10px 20px;\"><b>数据融合，多维分析</b><br />以运营商数据感知“出行需求”，以公交数据反映“公交供给”，全要素的数字化感知，供需平衡分析、资源利用率分析。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_02.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>逐层挖掘，综合诊断</b><br />宏观诊断、中观揪因、微观调优、综合诊断，逐层深入的问题挖掘和致因分析，确定优化方向。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_03.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>靶向方案，精准调优</b><br />短板提升，综合提升，优化方案覆盖公交结构、线网、场站、调度、公交优先等维度，基于需求的定制化落地实施方案。</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_04.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>方案跟踪，系统评估</b><br />长周期跟踪分析，方案实施前后的效果评估和对比验证，建立循环调优机制。</p>"+
            "</div>"+
          "</div>"
        },
        {
          name:"服务优势",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div class=\"clearfix\" style=\"width: 100%;\">"+
          "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk05.jpg')+"\" />"+
          "<p style=\"margin:120px 30px; line-height:1.8;\"><b>出行感知新方法</b><br />基于运营商大数据的居民出行需求感知方法，成本更低、效率更高、精度更高、时空覆盖更广，与传统的问卷调查法相比，优势更明显。</p>"+
          "</div>"+
          "<div class=\"clearfix\" style=\"width: 100%;\">"+
          "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk04.jpg')+"\" />"+
          "<p style=\"margin:120px 30px; line-height:1.8;\"><b>数据融合新突破</b><br />打通运营商、互联网、社会经济、城市基建及公交、轨道、出租车、网约车、社会车等多源数据，数据体量超过千亿，构建多维度、多层次公交状况分析的数据基础。</p>"+
          "</div>"+
          "<div class=\"clearfix\" style=\"width: 100%;\">"+
          "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk03.jpg')+"\" />"+
          "<p style=\"margin:120px 30px; line-height:1.8;\"><b>公交评价新标准</b><br />构建线路运营效率、公交乘客满意度等多个定量评价模型，分析维度覆盖全方式整体出行人群，重点关注公交出行和公交运营的系统性评价，分析结果更全面、更真实、更准确。</p>"+
          "</div>"
        },
        {
          name:"系列产品",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">A、大数据公交优化方案</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk06.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk07.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">B、公交可视化监控平台</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk08.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk09.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">C、公交仿真分析系统</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk10.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk11.jpg')+"\" />"+
          "</div>"+
          "</div>"
        }
      ]
    }
  },
  "en":{
    cityService:{
      img1:require('./assets/img/ywbk_tuc.jpg'),
      icon1:require('./assets/img/ywbk_city.png'),
      text1:"The service systems make full use of big data technology to drive the development of smart city. We integrate multi-source heterogeneous data,and innovate brand new application scenarios for big data. With the help of AI algorithms, big data models, and varieties of data visualization(presentation) tools, we can provide the decision makers with critical information as soon as possible, so as to support the operations, plans and constructions of the city.",
      data1:{
        thumb:require('./assets/dataimg/ywbk18_en.jpg')
      },
      serveic:[
        {
          name:"Products",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"margin-bottom: 100px;\">"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          "Integrated & Multi-Terminal Monitoring Platform"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">Product 1</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_19.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Integrated Data Pool & Multi-Terminal Display</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">Users could obtain the data they care about at anytime and anywhere by this platform through multiple methods such as Mini program (Mobile) and digital monitor(PC).</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_20.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Precise Pre-warning Achieved by Proprietary Data Models</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">22 business segments, 42 layers of government data as well as corresponding data models have been reorganized and summarized, which provide precise pre-warnings vary from different business requirements.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_21.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Quickly Get and Post Data Based on Smart Data Channels</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">Reorganize and summarize the data channel directly via business system interfaces, requiring business-related employees only, averaging 4 APIs each day interfaceable.</p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div style=\"margin-bottom: 100px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk20_en.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          "Iot Platform Service"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">Product 2</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_22.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Private Deployment Support</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">Solved problems of government data property rights and the management of IoT terminals.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_23.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Decoupling at Device Layers</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">Provide plentiful access protocol support and flexible data model definitions，allowing more protocols and suppliers to join.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_24.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>A Complete Set of IoT Application Services</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">The service provides early-stage solutions, mid-term construction support and post-operation support. It assists managers to make full use of the platform.</p>"+
            "</div>"+
          "</div>"+
          
          
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk22.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          "Target Message Service Platform"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">Product 3</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_03.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Precise Target Message Service</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">The service enables to choose the message target area through the various shapes of the GIS map. It provides excellent performance of precisely targeted message service based on the big data of mobile phone operators.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_09.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Multi-mode Support</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">The platform support ordinary,targeted and other types of SMS.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_15.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Multi-Operators</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">Supports message service accroding to three major operators: China Mobile, China Telecom, and China Unicom, on one platform.</p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk24.jpg')+"\" /></div>"+
          "<div>"+
          
          "<div style=\"text-align: center;width: 100%; margin: 80px 0;\">"+
          "<div style=\"border: 1px solid #3b436c;font-weight:700; font-size: 28px;color: #3b436c;padding: 5px 50px; border-radius: 10px;display:inline-block;position:relative\">"+
          "Emergency Message Report&Submition Platform"+
          "<div style=\"position: absolute; background-color: #3b436c;color: #fff; top:-15px;left:-50px; font-size: 16px; padding:5px 15px; border-radius: 4px;font-weight: 400;\">Product 4</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_04.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Flexible Customized Content for Report&Submition</b></p>"+
            "<p style=\"text-align:left; padding: 10px 20px;\">The administrator could quickly customize the report content template according to different emergency events and emergency plans, and send it to the mobile terminal of each reporting person with one click.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_25.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Smart&On Time Notification</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">Refer to regulations of Emergency Report&Submit, the reporter could be notified to fill in the information by auto-dial & messages system. </p>"+
            "</div>"+
            "<div style=\"float:left; width: 33.333%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_26.png')+"\" />"+
            "<p style=\"text-align: center;\"><b>Convenient Data Statistics</b></p>"+
            "<p style=\"text-align:left;padding: 10px 20px;\">Based on the reported data reported by the topics, which is corresponding to the emergency scenario summary, the backend can summarize data sheets quickly, which provide support for the decision making in emergency control. </p>"+
            "</div>"+
          "</div>"+
          
          "</div>"+
          "<div><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk26.jpg')+"\" /></div>"
        },
        {
          name:"Service Advantages",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div style=\"margin-bottom: 20px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk27_en.jpg')+"\" /></div>"+
          "<div style=\"margin-bottom: 20px;\">"+
          
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_16.png')+"\" /></div>"+
          "<div style=\"float: left; padding:20px;width: calc(100% - 140px);\"><b>Specialists</b><br />Difficulties in Smart City construction like strategic plans, research standards, critical technologies and models are figured out by professors and academics at home and overseas, who delve in the field of Smart City.</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_17.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;width: calc(100% - 140px);\"><b>Core Technologies</b><br />With low cost, our service could quickly break through isolated data with smart data channel, in order to solve integration problems in Smart City construction.</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_18.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;width: calc(100% - 140px);\"><b>United Innovation Lab</b><br />To solve problems in data application and innovation, the United Innovation Lab supports the entire life circle of big data products, by integrating multi-source data from government, operators and companies. </div>"+
          "</div>"+
          
          "</div>"
        }
      ]
    },
    smartPark:{
      img1:require('./assets/img/ywbk_tuy.jpg'),
      icon1:require('./assets/img/ywbk_05.png'),
      text1:"Smart park solutions are oriented to various types of technology parks, industrial development zones, and new industrial cities, etc. Based on the IoT management and big data platform, smart park solutions will help to create an intelligent and standardized smart parks, to provide better service experience for users, scientific service support for park operators, and accurate decision-making basis for government.",
      data1:{
        thumb:require('./assets/dataimg/ywbk12_en.jpg')
      },
      serveic:[
        {
          name:"Product Features",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"margin-bottom: 100px; position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu01.jpg')+"\" />"+
          "<div style=\" position: absolute; right:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_12.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>Comprehensive perception & Central monitoring</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">The solutions cover information and functions of each intelligent system of the park IoT management platform,so that park managers can monitor and manage each intelligent system on the monitoring center or mobile client.</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"margin-bottom: 100px;position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu02.jpg')+"\" />"+
          "<div style=\" position: absolute; left:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_13.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>Business collaboration & Intelligent linkage</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">The solutions are centered on the park IoT management platform. Through deep business integration,all intelligent systems can be integrated and thus  realize cross-system collaboration and linkage at the business level.</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"position:relative;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywu03.jpg')+"\" />"+
          "<div style=\" position: absolute; right:0; top: 0; margin-top: 90px; width: 40%;text-align:center\">"+
          "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_15.png')+"\" />"+
          "<p style=\"font-size: 22px;\"><b>Data analysis & Decision support</b></p>"+
          "<p style=\"text-align:left; font-size: 14px; padding: 10px 40px;\">To meet the needs of various business management and  visualized graphic scenarios, the solution uses big data platform to combine the data from the park's IoT management platform and other data sources for data mining analysis and auxiliary decision-making.</p>"+
          "</div>"+
          "</div>"
        },
        {
          name:"Product Advantages",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div style=\"margin-bottom: 20px; \">"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_09.png')+"\" /></div>"+
          "<div style=\"float: left; padding:20px;width: calc(100% - 150px);\"><b>Fast Data Connection</b><br />The IoT management platform can quickly connect to the intelligent subsystem of the smart park, and then break through the system barriers to realize data collection and control of the intelligent system.</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_10.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;width: calc(100% - 150px);\"><b>Multi-source Data Fusion</b><br />The solution uses data resources such as operator data, park data, and network data to comprehensively analyze the personnel, traffic, consumption, and other data of smart parks, and dynamically analyze business conditions to guide parks in operation.</div>"+
          "</div>"+
          "<div style=\"overflow:hidden; padding: 20px;\">"+
          "<div style=\"float: left; width: 90px;\"><img style=\"width: 100%;\" src=\""+require('./assets/img/ywbk_11.png')+"\" /></div>"+
          "<div style=\"float: left;padding:20px;width: calc(100% - 150px);\"><b>Standard Application Module</b><br />The solution provides standardized application functions, covering monitoring, management, and analysis for decision-making. According to the needs of different parks and the construction of intelligent equipment, the application modules can be configured on-demand.</div>"+
          "</div>"+
          "</div>"+
          "<div style=\"margin-bottom: 20px;\"><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/ywbk17_en.jpg')+"\" /></div>"
        }
      ]
    },
    smartTransportation:{
      img1:require('./assets/img/ywbk_tuj.jpg'),
      icon1:require('./assets/img/ywbk_05.png'),
      text1:"With the help of the real-time, high coverage data provided by the mobile operators, cooperate with multi-source digital information from public transportation, the professional, at the same time customized public transportation optimization program based on big data has the chance to come true. ",
      data1:{
        thumb:require('./assets/dataimg/data1_en.jpg')
      },
      serveic:[
        {
          name:"Content",
          icon1:require('./assets/img/ywbk_xiangmu-bai.png'),
          icon2:require('./assets/img/ywbk_xiangmu-hei.png'),
          content:"<p><b>Public Transportation Optimization Integrated Solution: </b>The prediction of travel demand, the coordination of supply and demand, scheme optimization and resource scheduling, the system of deduction, evaluation,  visible monitor, and other full-process services.</p>"+
          // "<p class=\"text-center\" style=\"margin:30px 0;\"><img style=\"width: 600px;\" src=\""+require('./assets/dataimg/data2.jpg')+"\" /></p>"+
          // "<p><img style=\"width: 100%;\" src=\""+require('./assets/dataimg/data3.jpg')+"\" /></p>"+
          "<div style=\"margin-top:100px;width: 100%; overflow:hidden; text-align:center;\">"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_01.png')+"\" />"+
            "<p style=\"text-align:left; padding: 10px 20px;\"><b>Data Connection and Multi-dimensional Analysis</b><br />According to the perception of travel demand is based on the data from the operator and \"public transportation\" data reflect transport information, the digital prediction, analysis of supply-demand balance, and analysis of resource utilization will be supplied.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_02.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>Layer-by-layer Mining and Multi-diagnosises</b><br />Analysis and diagnosis problems from different perspectives, digging deeper to find the reason and causal analysis, to determine the optimization plan.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_03.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>Scheme and Optimization</b><br />We provide customized implementation scheme to optimize the public transport structure, network, transit station,  bus priority, etc.</p>"+
            "</div>"+
            "<div style=\"float:left; width: 25%;text-align:center\">"+
            "<img style=\"width: 90px;height: 90px;\" src=\""+require('./assets/img/ywbk_04.png')+"\" />"+
            "<p style=\"text-align:left;padding: 10px 20px;\"><b>Scheme Tracking and System Evaluation</b><br />Tracking analysis in a long-term period, according to the effect evaluation and comparative verification after implementation scheme, and establishenment of a circular optimization method.</p>"+
            "</div>"+
          "</div>"
        },
        {
          name:"Service Advantages",
          icon1:require('./assets/img/ywbk_youshi_bai.png'),
          icon2:require('./assets/img/ywbk_youshi_hei.png'),
          content:"<div class=\"clearfix\" style=\"width: 100%;\">"+
          // "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk05.jpg')+"\" />"+
          "<p style=\"margin:60px 30px; line-height:1.8;\"><b>New Method for Travel Analysis</b><br />Comparing with the traditional questionnaire surveys, our new way for travel analysis which bases on mobile operators' big data contains lower cost,higher efficiency, higher precision and wider coverage on both temporal and spatial dimensions.</p>"+
          "</div>"+
          "<div class=\"clearfix\" style=\"width: 100%;\">"+
          // "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk04.jpg')+"\" />"+
          "<p style=\"margin:60px 30px; line-height:1.8;\"><b>New Break for Data Connection</b><br />With hundres of billions of data volunm, connected with  mobile operators, the Internet,social economy, urban infrastructure, railway, taxi and online-hailing cars and other multi-source data the latest  multidimensional public transportation analysis approach has already been built.</p>"+
          "</div>"+
          "<div class=\"clearfix\" style=\"width: 100%;\">"+
          // "<img style=\"float:left;height:280px;width:460px;margin:40px 50px 0 0;box-shadow:0 0 10px #ccc;\" src=\""+require('./assets/dataimg/ywbk03.jpg')+"\" />"+
          "<p style=\"margin:60px 30px; line-height:1.8;\"><b>New Standard for Public Transportation Evaluation</b><br />In order to obtain accurate and comprehensive results, it is necessary to construct evaluation models, which contain route efficiency and customer satisfaction, and analyze every possible option for all travel passengers.</p>"+
          "</div>"
        },
        {
          name:"Products",
          icon1:require('./assets/img/ywbk_chanpin_bai.png'),
          icon2:require('./assets/img/ywbk_chanpin_hei.png'),
          content:"<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">A、Bus Optimization Scheme (Based on Big Data)</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk06_en.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk07_en.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">B、Visualized Monitoring Platform</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk08_en.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk09_en.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "<div style=\"overflow:hidden;margin-bottom: 40px;\">"+
          "<h2 style=\"margin:10px 020px;\">C、Analysis System for Public Transtportation</h2>"+
          "<div>"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px 50px 20px 20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk10_en.jpg')+"\" />"+
          "<img style=\"float:left;height:340px;width:530px;margin:20px;box-shadow:0 0 20px #ccc;\" src=\""+require('./assets/dataimg/ywbk11_en.jpg')+"\" />"+
          "</div>"+
          "</div>"
        }
      ]
    }
  }
};

//新闻内容
export const news = {
  "zh-CN":{
    salon:{
      list:[
        {
          title:"2020科研沙龙系列",
          thumb:require('./assets/dataimg/new-salon-2thumb.jpg'),
          id:2,
          content:`<div>
            <img style="position:absolute;left:0;top:1520px" src="${require('./assets/img/news/webnew-salon2-content-left.png')}" />
            <img style="position:absolute;right:0;top:1493px" src="${require('./assets/img/news/webnew-salon2-content-right.png')}" />
            <div style="width: 100%;position:relative;overflow:hidden;">
              <img style="position:relative;margin-left:-960px;left:50%;" src="${require('./assets/img/news/webnew-salon2-content1.png')}" />
            </div>
            <div style="width: 1200px;margin: 40px auto;position:relative;overflow:hidden;">
              <img style="position:relative;margin-left:-600px;left:50%;" src="${require('./assets/img/news/webnew-salon2-content2.png')}" />
              <p style="position:absolute;top:40px;right:50px;bottom:40px;padding:52px 40px;width:455px;background:#fff;border-radius:5px;font-size:16px;text-align: justify;">2020年8月25日，由珠海（国家）高新区科产局指导、珠海市岭南大数据研究院主办的2020年科研沙龙——“基于5G的数字产业大脑研发和应用科研沙龙”在珠海举行。以“数字技术赋能智慧园区”为主题，汇聚国内智慧园区领域的专家及优秀企业，共同探讨智慧园区的未来与发展。</p>
            </div>
            <div style="width: 1200px;margin: -15px auto 0 auto;position:relative;overflow:hidden;">
              <img style="position:relative;margin-left:-600px;left:50%;" src="${require('./assets/img/news/webnew-salon2-content3.png')}" />
              <p style="position:absolute;top:90px;left:100px;width:790px;font-size:16px;text-align: justify;">
                智慧园区作为智慧城市的缩影，其规划建设可以为智慧城市建设积累重要的经验。<br />
                正如岭南大数据研究院副院长滕雷在开幕致辞中所言，自2017年开始，在自上而下推动智慧城市建设趋势之外，又出现了自下而上的建设趋势，以产业园区的数字化转型推动智慧城市的向前发展，产业园区作为企业员工生活生产的典型场景，也需要进行变革。<br />
                基于此，我们需要一场关于智慧园区的“头脑风暴”，共同探索智慧园区建设的新思路。
              </p>
            </div>
            <p style="margin:70px auto 40px;padding:50px 0;font-size:24px;text-align:center;background:url(${require('./assets/img/news/webnew-salon2-content-title.png')}) center no-repeat;">视频回放</p>
            <div class="text-center" style="width: 100%;position:relative;overflow:hidden; margin-top: 40px;">
              <video controls poster="${require('./assets/img/news/webnew-salon2-content-video.png')}" style="width:1200px;margin:0;" src="https://www.chiefdata.org.cn/video/blockchain/salon2.mp4" >
                您的浏览器不支持 video 标签。
              </video>
            </div>
            <p style="margin:70px auto 40px;padding:50px 0;font-size:24px;text-align:center;background:url(${require('./assets/img/news/webnew-salon2-content-title.png')}) center no-repeat;">嘉宾介绍</p>
            <div style="margin:0 auto;width:1200px;overflow:hidden">
            <div style="margin:-12px;width:1248px;overflow:hidden">
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p1.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">珠海高新发展李金成：智慧产业园规划构想</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">珠海高新发展有限公司李金成展示了珠海高新发展有限公司对于智慧园区系统架构蓝图，他认为，园区的基础建设、深化拓展以及服务创新是建立一个能够真正助力企业生产的产业园的重点。如果要实现园区大数据平台和企业数据之间的融合，需要构建一个园区内的大数据共享平台。只有创新与合作才能产生共赢。</p>
                </div>
              </div>
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p2.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">超图软件褚继富：SuperMap GIS 赋能智慧园区</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">褚继富认为经济园区、社区、旅游景区、化工园区等，都是智慧园区所涉及的范围。他还提出智慧园区的建设目标是“四个智”：智编码，智地图，智分析，智决策；“四个能”：能可控（完全自主可控），能安全（全方位的安全体系），能生态（基于微服务化的API生态），能自治（智能运维监控平台）。</p>
                </div>
              </div>
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p3.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">大道智创魏金生：智慧安防在智慧园区的示范应用</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">在深圳市大道智创科技有限公司魏金生看来，未来智慧园区的应用是以数字平台为核心，通过机器人、物联网，将园区连接起来的。目前园区的安防工作在人防、物防、技防、政策支持等问题上都存在着诸多问题，而使用安防机器人可为智慧园区提供智慧化整体安防配套服务，是园区未来的发展趋势。</p>
                </div>
              </div>
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p4.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">镜像视觉科技曲付：智慧园区三维可视化的建设思路</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">曲付指出，动态展示建筑结构是二维可视化和三维可视化的最大的区别。三维可视化可以将园区所有设备纳入到视频数据可视化中，对所有的设备进行集中化的管理，可以增强园区管理效率。他相信，数据可视化未来定将可以通过园区延伸到智慧城市建设中。</p>
                </div>
              </div>
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p5.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">岭南大数据研究院朱勇：数字产业大脑赋能智慧园区</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">如果按照原来单一条块完成智慧园区的服务，势必会造成系统孤岛、数据孤岛，从而服务也有局限性。朱勇表示，基于此，珠海岭南大数据研究院提出，打造围绕5G应用的公共技术服务平台，为5G示范应用提供共性支撑，为5G新应用提供扩展空间，还可以提供面向园区企业和支撑政府提供决策的一系列公共服务。</p>
                </div>
              </div>
              <div style="float:left;width:588px;margin:12px;font-size:0;">
                <img src="${require('./assets/img/news/webnew-salon2-content-p6.png')}" />
                <div style="padding:26px 50px 0;height:254px;background:#3136ac;color:#fff;">
                  <p style="line-height:36px;font-size:20px;margin-bottom:12px;">数库科技陆忠明：产业大数据推动产业数字化转型</p>
                  <p style="line-height:36px;font-size:16px;text-align: justify;">陆忠明表示，构建科学的产业链数据体系可以驱动产业园区和园区内企业进行精细化管理和科学决策。产业园区和企业引入高质量的产业链体系框架，在传统的国际分类基础上，可以提升产业分析颗粒度，构建全产业上下游价值链，也可以实现产业链的横向拓展和纵向拓展。</p>
                </div>
              </div>
            </div>
            </div>
            <p style="margin:70px auto 40px;padding:50px 0;font-size:24px;text-align:center;background:url(${require('./assets/img/news/webnew-salon2-content-title.png')}) center no-repeat;">圆桌论坛</p>
            <div style="width: 100%;position:relative;overflow:hidden;">
              <img style="position:relative;margin-left:-960px;left:50%;" src="${require('./assets/img/news/webnew-salon2-content4.png')}" />
              <p style="position:absolute;top:180px;left:0;right:0;text-align:center;font-size:20px;color:#fff">在圆桌论坛环节中，其他产业嘉宾也分享了各自对于智慧园区建设的见解。</p>
            </div>
            <div style="position:relative;width:1200px;margin:30px auto;background:#e4e4e4;overflow:hidden;">
              <div style="float:left;padding: 95px 48px 0;width:516px;font-size:16px;">
                <p style="margin-bottom:55px;">
                  <span style="position:relative;padding-right:45px;font-size:30px;">
                    马略武
                    <i style="position:absolute;top:16px;right:18px;width:24px;height:4px;background:#2d2ad9;"></i>
                    <i style="position:absolute;bottom:8px;right:8px;width:24px;height:4px;background:#ab08d0;"></i>
                  </span>
                  珠海华发产业园运营管理有限公司产业孵化副总经理
                </p>
                <p style="text-align: justify;">珠海华发产业园运营管理有限公司产业孵化副总经理马略武分享了运营公司目前在智慧园区建设方面参与的情况。他以华发为例，介绍其智慧园区正努力实现三个目标：运营信息化、数据智能化和统一协同化。</p>
              </div>
              <img style="float:left;" src="${require('./assets/img/news/webnew-salon2-content-p7.png')}" />
            </div>
            <div style="position:relative;width:1200px;margin:30px auto;background:#e4e4e4;overflow:hidden;">
              <img style="float:left;" src="${require('./assets/img/news/webnew-salon2-content-p8.png')}" />
              <div style="float:left;padding: 95px 48px 0;width:516px;font-size:16px;">
                <p style="margin-bottom:55px;">
                  <span style="position:relative;padding-right:45px;font-size:30px;">
                    陈明师
                    <i style="position:absolute;top:16px;right:18px;width:24px;height:4px;background:#2d2ad9;"></i>
                    <i style="position:absolute;bottom:8px;right:8px;width:24px;height:4px;background:#ab08d0;"></i>
                  </span>
                  广州快盈信息技术服务有限公司数据总监
                </p>
                <p style="text-align: justify;">企业情报平台可以帮助企业收集相关重要信息，辅助企业做一些决策。在园区内，陈明师认为园区可以做整合平台，提供给相关方做订阅，这样可以快速了解到它的竞争对手的舆情情况，然后去做一些相应的投资决策。</p>
              </div>
            </div>
            <p style="margin:70px auto 40px;padding:50px 0;font-size:24px;text-align:center;background:url(${require('./assets/img/news/webnew-salon2-content-title.png')}) center no-repeat;">沙龙总结</p>
            <div style="width: 100%;position:relative;font-size:0;overflow:hidden;">
              <img style="position:relative;margin-left:-960px;left:50%;" src="${require('./assets/img/news/webnew-salon2-content5.png')}" />
              <p style="position:absolute;top:240px;left:-498px;margin-left:50%;width:996px;text-align:left;font-size:18px;color:#fff;text-align: justify;">本次“基于5G的数字产业大脑研发和应用科研沙龙”所探讨的数字产业大脑建设、三维可视化发展、智慧安防、产业链框架体系建设、企业情报平台等应用和技术，深度的剖析了智慧园区建设的现状与趋势，同时也为智慧园区的建设带来了新的“解题思路”。</p>
            </div>
            <div style="margin:0 auto -60px;padding:59px 0;max-width:1920px;height:64px;line-height:64px;background:#000e42;color:#fff;text-align:center;font-size:24px;">
              您期待的下场科研沙龙主题是什么呢？快来投票告诉我们吧！
              <a href="https://tp.wjx.top/jq/89404278.aspx" target="_blank" style="display:inline-block;margin-left:20px;width:320px;background:#76efff;color:#1e1ae6;text-decoration: none;border-radius:5px;">去投票</a>
            </div>
          </div>`,
          datetime:"2020-8-25"
        },
        {
          title:"珠海市区块链与信息安全国际研讨会",
          thumb:require('./assets/dataimg/new01.jpg'),
          id:1,
          content:"<div>"+
          "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/img/news/webnew01.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new07.jpg')+"\" /></div>"+
          "<div style=\"width: 1200px;margin: 40px auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 50%;float:left;overflow:hidden;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew02.jpg')+"\" />"+
          "</div>"+
          "<div style=\"width: 50%;float:left;overflow:hidden; padding: 0 20px; box-sizing: border-box;\">"+
          "<p style=\"font-size: 18px;margin-top:10px; text-indent:2em;\">11月22日，珠海市区块链与信息安全国际研讨会在珠海高新区隆重举行，会议由珠海市岭南大数据研究院主办。珠海市工业与信息化局副局长扶志同志、珠海市科学技术协会主席刘治民同志出席开幕式并致辞。珠海市岭南大数据研究院院长朱晓蕊教授主持会议，珠海市岭南大数据研究院理事长周路明同志出席会议。</p>"+
          "<p style=\"font-size: 18px;margin-top:40px; text-indent:2em;\">本次研讨会以“推动数据融合，打造应用场景”为主题，汇聚了政产学研界权威专家、知名学者、资深企业家，共同探讨区块链技术在大数据领域的创新场景应用，为区块链、信息安全及大数据领域的国内外学者与技术人员提供了一个最新的理论与技术成果的交流展示平台。</p>"+
          "</div>"+
          "</div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new08.jpg')+"\" /></div>"+
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:475px;background:url("+require('./assets/img/news/webnew03.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 50%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 18px; width:500px;margin-top:150px;margin-left: 30px;\">出席本次研讨会的嘉宾有珠海市科协、珠海市工信局、珠海高新区、珠海横琴新区政府部门领导；澳门科技大学、中山大学、广东工业大学等8家高校和科研院所专家；远光软件、同望科技、澳门电讯、飞企互联、汇金科技、珠海移动、珠海联通、珠海电信等18家企业的28位嘉宾，以及7家主流媒体代表，近80人。 </p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "<div class=\"text-center\" style=\"width: 100%;position:relative;overflow:hidden; margin-top: 40px;\">"+
          "<video controls poster=\""+require('./assets/dataimg/v1.jpg')+"\" style=\"width:1200px;margin:0;\" src=\"https://www.chiefdata.org.cn/video/blockchain/短视频（字幕版）.mp4\" >"+
          "您的浏览器不支持 video 标签。"+
          "</video>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "开幕式"+
          "</h2>"+
          
          "<div style=\"width: 1200px;height:344px;margin:auto auto 50px;position:relative;overflow:hidden;background:url("+require('./assets/img/news/webnew05.png')+") center no-repeat; \">"+
          "<h3 style=\"margin-left: 380px; width: 780px; margin-top:60px;font-size: 24px; font-weight: 400;color:#fff;position:relative;\">"+
          "珠海市岭南大数据研究院院长朱晓蕊主持会议"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#fff;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"color: #fff;font-size: 20px;margin-left: 380px; margin-top: 20px;  width: 780px;\">珠海市岭南大数据研究院院长朱晓蕊教授代表研究院热烈欢迎各位领导、嘉宾及媒体代表的到来，并表示研究院将在区块链与信息安全领域加快引进国际一流的前沿技术人才，推动更多新技术、新产品、新模式在珠海率先应用，为推动珠海数字经济产业高质量发展发挥更大作用。</p>"+
          "</div>"+
          
          "<div style=\"width: 1200px;height:344px;margin:auto auto 50px;position:relative;overflow:hidden;background:url("+require('./assets/img/news/webnew06.png')+") center no-repeat; \">"+
          "<h3 style=\"margin-left: 380px; width: 780px; margin-top:60px;font-size: 24px; font-weight: 400;color:#fff;position:relative;\">"+
          "珠海市工业与信息化局副局长扶志致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#fff;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"color: #fff;font-size: 20px;margin-left: 380px; margin-top: 20px;  width: 780px;\">市工业与信息化局副局长扶志同志对研讨会的举办表示祝贺，并强调新一代信息产业重点是珠海“二次创业”的重要抓手，珠海将着力在区块链和大数据技术等领域培育、发展和打造一批具有国际影响力的科研机构、平台和企业。</p>"+
          "</div>"+
          
          "<div style=\"width: 1200px;height:344px;margin:auto auto 50px;position:relative;overflow:hidden;background:url("+require('./assets/img/news/webnew07.png')+") center no-repeat; \">"+
          "<h3 style=\"margin-left: 380px; width: 780px; margin-top:60px;font-size: 24px; font-weight: 400;color:#fff;position:relative;\">"+
          "珠海市科学技术协会主席刘治民致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#fff;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"color: #fff;font-size: 20px;margin-left: 380px; margin-top: 20px;  width: 780px;\">市科学技术协会主席刘治民同志对与会嘉宾表示热烈的欢迎，希望珠海市岭南大数据研究院继续发挥雄厚的科研实力、丰富的数据资源和独特的体制机制等优势，及时跟踪区块链的发展动态，积极引入区块链高端人才，加强与全球顶尖人才的交流合作，为珠海市区块链行业的人才、要素流动保驾护航。</p>"+
          "</div>"+
          
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "专家主题报告分享"+
          "</h2>"+
          
          
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:801px;background:url("+require('./assets/img/news/webnew08.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 84%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 20px;;margin-top:400px;margin-left: 130px;\">本次国际研讨会特邀英国皇家工程院院士、欧洲科学院院士、深圳市和信中欧金融科技研究院院长Bill Roscoe教授；中国科学院信息工程研究所操江峰博士；投资专家、金融数据领域创业者融数联智CEO袁晔先生；国际SM9标识密码算法标准发起人和编制人、深圳奥联信息安全技术有限公司CTO程朝辉博士带来精彩的主题分享。 </p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          "<div style=\"width: 1200px;margin:50px auto;position:relative;overflow:hidden;\">"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew09.jpg')+"\" />"+
          "<div style=\"margin:30px;\">"+
          "<h3 style=\"font-size: 24px; margin-bottom: 30px; font-weight: 400;position:relative;\">"+
          "Bill Roscoe教授演讲"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"height:160px;\">Bill Roscoe教授带来《金融行业的主流区块链》的主题分享，从能耗、匿名性、不稳定的加密货币、效率、早期用户出发，分析了横亘在区块链成为主流技术面前的五座大山，深入探讨了区块链向低耗、高效、安全、合规的方向发展的技术演化路径，为与会嘉宾描绘了区块链成为主流技术的未来图景。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew10.jpg')+"\" />"+
          "<div style=\"margin:30px;\">"+
          "<h3 style=\"font-size: 24px; margin-bottom: 30px; font-weight: 400;position:relative;\">"+
          "操江峰博士演讲"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"height:160px;\">操江峰博士以坚实的理论和前瞻性的战略视野，介绍了支持隐私保护的超级服务器平台的架构及相关技术。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew11.jpg')+"\" />"+
          "<div style=\"margin:30px;\">"+
          "<h3 style=\"font-size: 24px; margin-bottom: 30px; font-weight: 400;position:relative;\">"+
          "袁晔先生演讲"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"height:160px;\">袁晔先生通过丰富的理论和实践经验，从数据安全和可得性的痛点出发，描述了可信数据安全可行的交换路径，对可信数据交换在金融、医学联盟、公共数据等领域的落地场景作了有益探讨。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew12.jpg')+"\" />"+
          "<div style=\"margin:30px;\">"+
          "<h3 style=\"font-size: 24px; margin-bottom: 30px; font-weight: 400;position:relative;\">"+
          "程朝辉博士"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"height:160px;\">程朝辉博士带来《基于国产密码的区块链隐私保护技术》的主题报告，从匿名币的隐私技术对比出发，通过生动的例子和详实的数据公式介绍了自主研发的创新型国产技术。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          "</div>"+
          
          
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "座谈交流"+
          "</h2>"+
          
          
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:801px;background:url("+require('./assets/img/news/webnew13.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 84%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 20px;;margin-top:340px;margin-left: 130px;\">此外，研讨会当天，在专家主题报告分享环节过后，现场嘉宾进行了座谈交流。来自同望科技股份有限公司的总经理孟要锋先生、珠海汇金科技股份有限公司研究院的副院长谌章义先生、澳门科技大学区块链研究方向博士生袁剑文等嘉宾，分别就有关区块链与信息安全主题的相关内容向与会专家进行了提问与交流，研讨会在热烈的讨论中画上了圆满的句号</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new10.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new11.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new12.jpg')+"\" /></div>"+
          "<div style=\"width: 100%;position:relative;overflow:hidden; text-align:center; margin-top: 40px;\"><img height=\"80px\" src=\""+require('./assets/dataimg/data5.png')+"\" /></div>"+
          
          "</div>",
          datetime:"2019-11-22"
        }
      ]
    },
    forum:{
      list:[
        {
          title:"2019岭南大数据国际论坛",
          thumb:require('./assets/dataimg/new04.jpg'),
          id:1,
          content:"<div>"+
          
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:662px;background:url("+require('./assets/img/news/webnew33.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 92%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:260px;margin-left: 124px; text-indent:2em;\">9月7日，在全球学术界、产业界的领袖精英的见证之下，工信部第二届“绽放杯”5G应用征集大赛之珠海智慧城市专题赛暨2019岭南大数据国际论坛在珠海国际会展中心隆重开幕。作为大数据、5G、智慧城市领域的大湾区高端学术论坛，此次论坛规模相比去年再度升级，与会人数创新高，全球创新创业企业汇聚于此，诸多享誉国内外的院士专家作为嘉宾重磅亮相。 </p>"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:20px;margin-left: 124px; text-indent:2em;\">本次活动由珠海市工业和信息化局、珠海市科技创新局、珠海（国家）高新区管委会、珠海市人才工作领导小组、中国移动广东公司珠海分公司、广东广电网络珠海分公司、珠海华发集团、珠海城建集团、珠海市岭南大数据研究院等主办，广东城智科技有限公司、珠海市岭南大数据研究院联合承办，得到了工信部、珠海市人民政府、中国移动研究院、中国移动广东公司等大力支持，吸引了来自全球5G、大数据、人工智能、物联网等领域顶级院士、专家和企业代表参会，旨在打造国内5G智慧城市领域高端学术交流峰会。</p>"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:20px;margin-left: 124px; text-indent:2em;\">论坛延续了去年强大的阵容，在历史与现在的起点上，深刻剖析未来科技改变世界的可能性，并展望新的5G时代。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #741dbc; line-height: 130px;background:url("+require('./assets/img/news/webnew32.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "开幕盛典"+
          "</h2>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; margin-left: 240px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "珠海市人民政府副市长阎武致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\" text-indent:2em;\">在上午的致辞中，珠海市人民政府副市长阎武首先登台致辞。他谈到了珠海在大数据产业的成果和举措，并表示珠海将进一步优化创新制度和政策环境，协力打造一批有国际影响力的大数据科研机构和研发平台，大力发展以5G、互联网、大数据、人工智能为代表的新一代信息产业，推进新型智慧城市的建设。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:left; margin-left:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew29.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:left;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "广东省工信厅副厅长杨鹏飞致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\" text-indent:2em;\">广东省工信厅副厅长杨鹏飞表示，大数据是21世纪的金矿，国家也在发展大数据战略，广东省近来发布一系列大数据发展计划，打造了一批大数据创新区、集聚区，建设了大数据综合实验区和孵化园区。</p>"+
          "<p style=\" text-indent:2em;\">未来2-3年，珠海会涌现千亿级的软件企业，下一步政府将出台政策措施，支持具有自主知识产权的优势企业快速发展。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:right; margin-right:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew30.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; margin-left: 240px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "珠海市工信局局长沈岩致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\" text-indent:2em;\">珠海市工信局局长沈岩介绍了珠海市大数据产业发展现状，他表示，在过去的一年中，珠海市大数据产业持续快速发展，大数据及相关产业总体产值已经达到 116 亿元。珠海市大数据分析与处理服务领域规模以上企业数量保持在 88 家左右，从业人员数量超过 2 万人，业内相关上市公司总数达到 20 家。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:left; margin-left:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew31.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #741dbc; line-height: 130px;background:url("+require('./assets/img/news/webnew32.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "发布签约仪式"+
          "</h2>"+
          
          "<div style=\"width: 100%;position:relative;height:717px;background:url("+require('./assets/img/news/webnew34.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 100%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 18px;margin-top:100px;text-indent:2em;\">2019岭南大数据国际论坛“珠海智慧城市成果发布”环节，在多位政府领导的见证下，智慧珠海综合服务平台、珠海市大数据中心、我的珠海APP、智慧珠海云计算中心、智慧社区等成果在现场发布。</p>"+
          "<p style=\"color: #fff;font-size: 18px;margin-bottom: 60px;text-indent:2em;\">澳门科技大学资讯科技学院与珠海市岭南大数据研究院共同就“珠澳智能互联与计算联合研究中心”成立举行了隆重签约。</p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:200px auto;;position:relative; overflow:hidden;\">"+
          "<div style=\"width:50%;float: left;\">"+
          "<div style=\"padding-right: 20px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew35.jpg')+"\" />"+
          "<p >珠海市高新区管委会苏虎主任致辞</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width:50%;float: left;\">"+
          "<div style=\"padding-left: 20px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew36.jpg')+"\" />"+
          "<p>珠海市岭南大数据研究院周路明理事长发表致辞</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          "<div style=\"width: 100%; margin-top:40px;position:relative;overflow:hidden;height:513px;background:url("+require('./assets/img/news/webnew37.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 700px;float:right;color: #fff; text-indent:380px; line-height: 106px;font-size: 26px;overflow:hidden;\">"+
          "黄铠教授"+
          "</div>"+
          "<div style=\"width: 700px;float:right;margin-right:60px;margin-top: 30px;overflow:hidden;\">"+
          "<p style=\"font-size: 18px;text-indent:2em;\">港中文教授、深圳市AI与机器人研究院中心主任、IEEE Fellow黄铠教授发表了《融合超算云与5G边缘计算升级大数据智能物联网应用》的演讲。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">黄铠教授主要从行业应用的角度出发，谈到了不同的高科技之间融合与整合问题。比如：实现高性能和 AI 应用的社交、移动、分析、云平台和物联网技术（SMACT）的融合；通过大数据分析、物联网传感和机器学习功能，为超算云提高人工智能应用；计算机视觉、智慧城市、医疗保健、智能制造、5G 认知系统应用于集成云和物联网平台。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 100%; margin-top:40px;position:relative;overflow:hidden;height:513px;background:url("+require('./assets/img/news/webnew38.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 700px;float:right;color: #fff; text-indent:380px; line-height: 106px;font-size: 26px;overflow:hidden;\">"+
          "陈世卿院士"+
          "</div>"+
          "<div style=\"width: 700px;float:right;margin-right:60px;margin-top: 30px;overflow:hidden;\">"+
          "<p style=\"font-size: 18px;text-indent:2em;\">美国国家工程院院士、美国艺术与科学院院士、美国网格超级计算机发明者陈世卿发表了《综合人工智能科学、超级计算科学 引领前沿脑科学研究》的演讲。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">陈世卿院士表示，随着认知科学与信息科技尤其是人工智能的融合，互联网会逐渐演变成一个类脑结构，对人类大数据进行储存和处理，形成人类大脑，同时会出现个人或者组织专用的数据储存和处理服务，这就是个人和组织的第三脑。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">他同时分享了第三脑技术经典案例，比如在识别视野衰退、提前发现老年痴呆、脑认知精细测量、脑疾病早期非介入式的预防检测与治疗等。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 100%; margin-top:40px;position:relative;overflow:hidden;height:513px;background:url("+require('./assets/img/news/webnew39.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 700px;float:right;color: #fff; text-indent:380px; line-height: 106px;font-size: 26px;overflow:hidden;\">"+
          "徐雷院士"+
          "</div>"+
          "<div style=\"width: 700px;float:right;margin-right:60px;margin-top: 30px;overflow:hidden;\">"+
          "<p style=\"font-size: 18px;text-indent:2em;\">欧洲科学院院士、上海交大AI研究院首席科学家徐雷发表了《人工智能科技对智慧城市未来的影响》的演讲。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">徐雷教授主要分享了自己对人工智能的看法，并简单探讨了智慧城市的话题。他认为，人工智能从某种意义上来说可以分为识别认知、形象思维和抽象思维三个维度，而当今人工智能第三次浪潮的核心突破本质上是在识别认知方面。当然，在基础理论和算法创新层面，中国同英美尚且有 5 到 10 年差距。关于智慧城市，徐雷教授认为，我国智慧城市的发展应该综合不同城市的情况，毕竟每个城市的痛点和优势不同，而在 4G/5G 网络的支撑下，地理距离已经不再重要，每个城市也没有必要进行重复建设；从这个角度出发，我国应当大力发展智慧城市集群。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 100%; margin-top:40px;position:relative;overflow:hidden;height:598px;background:url("+require('./assets/img/news/webnew40.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 700px;float:right;color: #fff; text-indent:380px; line-height: 106px;font-size: 26px;overflow:hidden;\">"+
          "汤涛院士"+
          "</div>"+
          "<div style=\"width: 700px;float:right;margin-right:60px;margin-top: 30px;overflow:hidden;\">"+
          "<p style=\"font-size: 18px;text-indent:2em;\">中国科学院院士、计算数学家、北京师范大学-香港浸会大学联合国际学院(UIC)校长汤涛发表了《大数据、人工智能与智慧教育》的演讲。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">汤涛院士表示大数据与智慧教育已经密不可分，并探讨了大数据、人工智能、物联网等创新技术如何推进智慧教育的发展问题。其中，在智慧教室方面，汤教授重点强调了物联网技术的应用，包括学生体质健康监测、教学设备管理、学习情境数据采集、教育安全监控与危机快速处理、扩展课外教学等。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">另外，他也强调了泛在网络的概念，也就是通信网、互联网、物联网的高度协同的和融合，将实现跨网络、跨行业、跨应用、异构多技术的融合与协同。</p>"+
          "<p style=\"font-size: 18px;text-indent:2em;\">他还表示，具体在智慧教育场景中，泛在网络将实现三方联通，包括：学习、生活与工作的连通；学校教育、家庭教育和社会教育的连通；手机、平板、PC、学习机、电视等各种终端设备的连通。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #741dbc; line-height: 130px;background:url("+require('./assets/img/news/webnew32.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "主题圆桌"+
          "</h2>"+
          
          "<div style=\"width: 100%;position:relative;height:643px;background:url("+require('./assets/img/news/webnew41.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 100%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 18px;margin-top:100px;text-indent:2em;\">2019岭南大数据国际论坛下午环节，创新性地设置了3个主题分享和3个主题圆桌，分别是“5G智慧城市”、“5G智慧交通”、“5G智慧园区”，重点研究智慧城市、智慧交通、智慧园区的最佳发展模式。</p>"+
          "</div>"+
          "<div style=\"width: 1220px;margin:200px -20px;position:relative; overflow:hidden;\">"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:20px; background-color: #eee;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew42.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px;\">欧比特卫星大数据事业部副总裁周学林带来《“珠海一号”卫星星座及绿水青山一张图》的演讲。他重点介绍了欧比特的业务布局，尤其是在“珠海一号” 卫星星座的发展过程。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:30px;background-color: #eee;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew43.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px;\">珠海市岭南大数据研究院无人驾驶研究中心学术带头人、一清科技创始人、香港科技大学刘明教授做了《深度学习在无人驾驶中的应用与挑战》的演讲，系统解释了深度学习如何解决无人驾驶全流程。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:30px;background-color: #eee;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew44.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px;\">千视通智慧城市事业部总经理时成阁博士带来了《5G时代下的智慧园区》的演讲，并对传统园区诸多亟待解决的漏洞问题给出了AIoT的对策。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 1200; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 800px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "主题圆桌:5G智慧城市"+
          "</h3>"+
          "<p>深圳大学智慧城市研究院副院长贺彪博士、江行智能联合创始人兼首席技术官樊小毅博士、京东城市华南区总经理杨阳、广东城智科技有限公司副总经理莫宏波、数位首席信息官刘猛等就“5G智慧城市”的话题展开头脑风暴，对政府宏观决策与企业微观技术把控做了各自经验的分享。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 400px; float:left;\">"+
          "<img style=\"width: 100%; display:block;\" src=\""+require('./assets/img/news/webnew45.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 1200; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 800px; float:left;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "主题圆桌:5G智慧交通"+
          "</h3>"+
          "<p>复星锐正执行总经理杜健、一清科技创始人、香港科技大学刘明教授、镭神智能联合创始人兼副总经理冯洪亮、AutoX中国区技术总监潘坚伟博士、世纪高通（四维图新）华南CTO 付炜、准时达国际供应链管理有限公司智链实验室主任庄子骏等人就“5G智慧交通”等话题展开交流，对无人驾驶技术进行了畅想。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 400px; float:right;\">"+
          "<img style=\"width: 100%; display:block;\" src=\""+require('./assets/img/news/webnew46.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 1200; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 800px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "主题圆桌:5G时代的智慧园区"+
          "</h3>"+
          "<p>北京大学教授、博士生导师、深圳市人工智能学会副理事长邹月娴、力维智联智慧城市研究院院长黄启明博士、腾讯海纳智慧社区总经理章显、零壹互联联合创始人余晓勇、平安智慧城市智慧政务高级总监张溪、深圳市左邻永佳科技有限公司董事长冯业猛等人就“5G智慧园区”的话题进行了思想碰撞，对未来园区形态做了大胆建言。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 400px; float:left;\">"+
          "<img style=\"width: 100%; display:block;\" src=\""+require('./assets/img/news/webnew47.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt01.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt02.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt03.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt04.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt05.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_lt07.jpg')+"\" /></div>"+
          "</div>",
          videos:[
            {
              title: "主持人开场",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/01主持人开场.mp4",
              thumb: require('./assets/img/f2019/luntanA_01.jpg')
            },
            {
              title: "珠海市人民政府副市长阎武致辞",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/02珠海市人民政府副市长阎武致辞.mp4",
              thumb: require('./assets/img/f2019/luntanA_02.jpg')
            },
            {
              title: "广东省工信厅副厅长杨鹏飞致辞",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/03广东省工信厅副厅长杨鹏飞致辞.mp4",
              thumb: require('./assets/img/f2019/luntanA_03.jpg')
            },
            {
              title: "珠海市大数据产业发展现状-沈岩",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/04珠海市大数据产业发展现状-沈岩.mp4",
              thumb: require('./assets/img/f2019/luntanA_04.jpg')
            },
            {
              title: "珠海智慧城市成果发布环节",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/05珠海智慧城市成果发布环节.mp4",
              thumb: require('./assets/img/f2019/luntanA_05.jpg')
            },
            {
              title: "珠澳智能互联与计算联合研究中心签约仪式",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/06珠澳智能互联与计算联合研究中心签约仪式.mp4",
              thumb: require('./assets/img/f2019/luntanA_06.jpg')
            },
            {
              title: "创赛团队颁奖",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/07创赛团队颁奖.mp4",
              thumb: require('./assets/img/f2019/luntanA_07.jpg')
            },
            {
              title: "黄铠教授-融合超算云与5G边缘计算升级大数据智能物联网应用",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/08黄铠教授-融合超算云与5G边缘计算升级大数据智能物联网应用.mp4",
              thumb: require('./assets/img/f2019/luntanA_08.jpg')
            },
            {
              title: "陈世卿院士-综合人工智能科学、超级计算科学-引领前沿脑科学研究",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/09陈世卿院士-综合人工智能科学、超级计算科学-引领前沿脑科学研究.mp4",
              thumb: require('./assets/img/f2019/luntanA_09.jpg')
            },
            {
              title: "徐雷院士-人工智能科技对智慧城市未来的影响",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/10徐雷院士-人工智能科技对智慧城市未来的影响.mp4",
              thumb: require('./assets/img/f2019/luntanA_10.jpg')
            },
            {
              title: "5G赋能智慧产业-杨光总经理",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/11.5G赋能智慧产业-杨光总经理.mp4",
              thumb: require('./assets/img/f2019/luntanA_11.jpg')
            },
            {
              title: "汤涛院士-人工智能科技对智慧城市未来的影响",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/12汤涛院士-人工智能科技对智慧城市未来的影响.mp4",
              thumb: require('./assets/img/f2019/luntanA_12.jpg')
            },
            {
              title: "“珠海一号”卫星星座及绿水青山一张图-周学林",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/13“珠海一号”卫星星座及绿水青山一张图-周学林.mp4",
              thumb: require('./assets/img/f2019/luntanA_13.jpg')
            },
            {
              title: "主题圆桌-5G赋能智慧城市与产业发展",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/14主题圆桌-5G赋能智慧城市与产业发展.mp4",
              thumb: require('./assets/img/f2019/luntanA_14.jpg')
            },
            {
              title: "深度学习在无人驾驶中的应用-刘明教授",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/15深度学习在无人驾驶中的应用-刘明教授.mp4",
              thumb: require('./assets/img/f2019/luntanA_15.jpg')
            },
            {
              title: "主题圆桌-5G智慧交通",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/16主题圆桌-5G智慧交通.mp4",
              thumb: require('./assets/img/f2019/luntanA_16.jpg')
            },
            {
              title: "5G时代的智慧园区-时成阁",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/17.5G时代的智慧园区-时成阁.mp4",
              thumb: require('./assets/img/f2019/luntanA_17.jpg')
            },
            {
              title: "主题圆桌-5G时代的智慧园区",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/18主题圆桌-5G时代的智慧园区.mp4",
              thumb: require('./assets/img/f2019/luntanA_18.jpg')
            }
          ],
          datetime:"2019-09-07"
        },
        {
          title:"工信部第二届“绽放杯”5G应用征集大赛之珠海智慧城市专题赛",
          thumb:require('./assets/dataimg/new03.jpg'),
          id:2,
          content:"<div>"+
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:662px;background:url("+require('./assets/img/news/webnew49.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 92%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:320px;margin-left: 124px;text-indent:2em;\">以人工智能为代表的全球新一轮科技创新正在步入大国竞争时代，其中5G技术更是各国争夺的焦点。时局之下，风口之上，国家工信部为推动5G技术的商用及产业发展，发起了围绕5G应用场景的优秀创新创业项目征集赛事系列。</p>"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:20px;margin-left: 124px;text-indent:2em;\">其中，由中国信息通信研究院和IMT-2020(5G)推进组联合主办，中国移动通信集团公司承办，在全国选拔出杭州、雄安、西安和珠海四个有代表性的城市举办“城市杯”专题赛事，助力5G产业的繁荣发展。</p>"+
          "<p style=\"color: #fff;font-size: 16px;;margin-top:20px;margin-left: 124px;text-indent:2em;\">2019年9月6日，工信部第二届“绽放杯”5G应用征集大赛之珠海智慧城市专题赛珠海总决赛成功举办，24支优秀团队激烈角逐一、二、三等奖项获胜名额，并有望为珠海新兴产业的结构布局再添生力军。本届珠海赛事由珠海市政府指导，珠海市工信局、珠海市科创局、珠海（国家）高新区管委会、珠海市人才工作领导小组办公室、中国移动广东公司珠海分公司、广东广电网络珠海分公司、珠海华发集团、珠海城建集团、珠海市岭南大数据研究院联合主办。</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #bc9c6a; line-height: 130px;background:url("+require('./assets/img/news/webnew50.jpg')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "开幕盛典"+
          "</h2>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; margin-left: 240px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "珠海市工信局局长沈岩致辞"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"text-indent:2em;\">沈岩局长表示，珠海正奋力打造粤港澳大湾区重要门户枢纽、珠江口西岸核心城市以及沿海经济带高质量发展典范，工信部第二届“绽放杯”5G应用征集大赛之珠海智慧城市专题赛暨2019岭南大数据国际论坛在此隆重举办，珠海创业活动达到新一轮高潮。</p>"+
          "<p style=\"text-indent:2em;\">希望各参赛团队在本届专题赛中全力以赴, 力争第一；同时欢迎各位朋友到珠海考察投资兴业，共谋发展。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:left; margin-left:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew51.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:left;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "珠海（国家）高新区投资环境推介"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"text-indent:2em;\">对珠海的战略资源、交通区位、产业特色、政策优势作了介绍。珠海迎来港珠澳大桥通车、粤港澳大湾区加快建设等历史性重大机遇，大力培育新产业新业态新模式，建设国际创新成果转化地、区域特色金融中心和国际高端人才集聚区，打造粤港澳大湾区经济新引擎。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:right; margin-right:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew52.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:1200px;margin:30px auto 0;\">"+
          "<div style=\"width: 960px; margin-left: 240px; padding:20px 0; background-color:#eee;\" class=\"clearfix\">"+
          "<div style=\"width: 640px; float:right;\">"+
          "<div style=\"padding: 30px 60px;\">"+
          "<h3 style=\"font-size: 24px; margin:0 0 40px; font-weight: 400;position:relative;\">"+
          "中国移动集团研究院<br />介绍5G联创合作-杨光总经理"+
          "<span style=\"display: inline-block; margin-left: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "</h3>"+
          "<p style=\"text-indent:2em;\">杨光总经理全面介绍了5G联创中央实验室的成立与发展状况。对“绽放杯”5G应用专题赛珠海赛道进行了详细的介绍，他表示，5G将渗透到智慧城市发展的众多关键领域，同时5G的发展也将与诸多领域进行结合，各项目总体发展市场前景可期，商业模式有待挖掘和验证。</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width: 560px; float:left; margin-left:-240px;\">"+
          "<img style=\"width: 100%;\" src=\""+require('./assets/img/news/webnew53.jpg')+"\" />"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #433b9f; line-height: 130px;background:url("+require('./assets/img/news/webnew54.jpg')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "参赛团队"+
          "</h2>"+
          
          "<div style=\"width: 100%;position:relative;height:643px;background:url("+require('./assets/img/news/webnew55.jpg')+") center 0 no-repeat;\">"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 100%;float:left;overflow:hidden;\">"+
          "<p style=\"color: #fff;font-size: 18px;margin-top:100px; margin-bottom: 40px;text-indent:2em;\">参加总决赛路演的24支创新项目团队可谓“纵横四海”——既有以珠海移动为主体的本土队伍，也有来自粤港澳大湾区城市群的近卫军，更有来自欧美日等地的远征军，完美体现了“聚集全球创新资源，探索5G智慧城市应用场景，推动珠海数字产业发展”的办赛宗旨。参加本届总决赛路演的24个项目具有比较高的科技含量和独创性，其中15个项目已经被产业资本重点关注，并获得了投资机构的融资，13个项目已经实现了二轮以上融资。</p>"+
          "</div>"+
          "<div style=\"width: 1220px;margin-left:-20px;position:relative; overflow:hidden;\">"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:20px; \">"+
          "<img style=\"width: 100%;height:258px\" src=\""+require('./assets/img/news/webnew56.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px; text-align: center;\">"+
          "一等奖团队"+
          "<br />"+
          "芯视微系统科技"+
          "</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:30px;\">"+
          "<img style=\"width: 100%;height:258px\" src=\""+require('./assets/img/news/webnew57.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px; text-align: center;\">"+
          "二等奖团队"+
          "<br />"+
          "一清科技/多尼卡"+
          "</p>"+
          "</div>"+
          "</div>"+
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"margin-left:30px;\">"+
          "<img style=\"width: 100%;height:258px\" src=\""+require('./assets/img/news/webnew58.jpg')+"\" />"+
          "<p style=\"margin: 5px 20px; height: 180px; text-align: center;\">"+
          "三等奖团队"+
          "<br />"+
          "香港科技大学/云洲智能/美国Smartenius"+
          "</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 1200px; margin:auto; border-top: 1px solid #433b9f; height:0; overflow:hidden;\"></div>"+
          
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>芯视微系统科技</b></p>"+
          "<p style=\"text-indent:2em;\">来自深圳芯视微系统科技有限公司的“微机电激光扫描芯片及智慧城市应用”项目，其带头人、美国斯坦福大学博士洪昌黎具有超过15年的MEMS及IC芯片技术积累，已取得31项国内外发明专利授权，公司在2019年完成A+轮融资，投后估值3.1亿元人民币。</p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>一清科技</b></p>"+
          "<p style=\"text-indent:2em;\">一清科技5G无人驾驶团队基于十余年导航技术科研沉淀，主要开发的产品有低速无人驾驶物流车、低速无人驾驶载人接驳车、无人驾驶安防监控车、全地形机器人平台、低成本室内导航系统、多融合传感器等，可提供路面场景动态规划、无人驾驶全栈技术集成到无人车场景深度部署等一体化解决方案。核心团队来自瑞士苏黎世联邦理工学院、新加坡南洋理工大学、香港科技大学、香港中文大学、中国科技大学浙江大学等国内外知名高校，研发人员近三十人；持续多年致力于无人驾驶以及无人驾驶相关领域的前沿科技研发，发展至今已经完成了两轮融资，并在2019年收到了来自富士康的量产订单邀约；</p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>多尼卡</b></p>"+
          "<p style=\"text-indent:2em;\">多尼卡团队因创新性地提出卫星/ATG+客舱4G/5G基站解决方案，直接使用手机4G/5G信号舱内的信号接入，利用已经实名认证的手机号码和运营商成熟计费系统，绕开航空Wi-Fi必须输入身份证、座位号等复杂的实名认证流程，绕开航空Wi-Fi必须进行的空中实时缴费，解决航空Wi-Fi无法实现短信二次验证而导致的业务重新开发问题，并实现了空中和地面一样的上网业务模式和业务体验。</p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>香港科技大学 </b></p>"+
          "<p style=\"text-indent:2em;\">香港科技大学无人码头团队将激光雷达、视觉与三维数据处理算法和深度学习相结合，提供从车体到软硬件及算法的L3、L4无人系统整体方案，围绕“机器人+AI”布局产品线、规划技术路线，掌握了全地形三维建图及导航、大范围视觉定位导航、激光视觉融合导航等先进技术。应用场景包括：码头内无人驾驶集装箱货车运营系统； </p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>云洲智能 </b></p>"+
          "<p style=\"text-indent:2em;\">珠海移动-云洲智能5G无人船团队依托5G超高带宽能力、高可靠性、低时延技术优势，面对不同领域需求，推出更多搭载5G技术的无人船产品，为无人船艇自主航行、自主靠泊、通信导航、网络安全、自动化控制等关键技术提供测试验证技术的条件，推动世界进入水上智能时代，预计市场占有率超过85%； </p>"+
          "</div>"+
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<p style=\"color:#433b9f; margin-top: 20px;\"><b>美国Smartenius </b></p>"+
          "<p style=\"text-indent:2em;\">美国Smartenius团队将纳米颗粒呈神经网络状分散于高性能基体材料间，制备有良好机械和电性能的智能皮肤，附着或内嵌在结构部件中，用于桥梁、输油管道、飞机机身等结构损伤实时监测。团队创始人刘昊博士曾就职于波音公司研发下一代可延展精益制造复合材料，CTO戴洪波是特拉华大学土木工程系博士，主要研究领域涵盖碳纳米结构、高性能纤维增强复合材料，压变传感器、智能传感系统优化等。 </p>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #433b9f; line-height: 130px;background:url("+require('./assets/img/news/webnew54.jpg')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "评委阵容"+
          "</h2>"+
          
          "<div style=\"width: 1200px;margin:auto;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 1220px;\">"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew61.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">朱 方 - 评审委员会主席</b>"+
          "<br />"+
          "深圳力合清源创业投资管理有限公司董事长，清华大学精密仪器学士、硕士，荷兰代尔夫特技术大学微细工程博士"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew62.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">杨 光 - 评审委员会副主席</b>"+
          "<br />"+
          "中国移动通信研究院产业与业务合作部总经理，北京邮电大学博士，教授级高级工程师"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew63.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">董振江 - 评审委员会副主席</b>"+
          "<br />"+
          "博士、研究员，国务院特殊津贴专家，中国人工智能学会常务理事与自然语言处理专委副主任、深圳市人工智能行业协会会长"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew64.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">温卫民</b>"+
          "<br />"+
          "深圳市中小企业信用融资担保集团总经理，华中科技大学哲学专业硕士、经济师"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew65.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">李炯城</b>"+
          "<br />"+
          "广东省电信规划设计院大数据工程院院长,博士，客座教授，教授级高级工程师"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew66.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">贺 新</b>"+
          "<br />"+
          "清华大学天津电子信息研究院创投总监，电子工程系科技成果转化负责人"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew67.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">芶彤军</b>"+
          "<br />"+
          "珠海高科创业投资管理有限公司总经理，清华大学电力系统及自动化专业本科、工程师"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew68.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">胡晓宇</b>"+
          "<br />"+
          "珠海城市建设集团有限公司（城建集团）总工程师，广东城智科技有限公司董事长、上海同济大学学士，暨南大学管理学硕士"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew69.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">刘 澎</b>"+
          "<br />"+
          "中国开源软件推进联盟副主席兼秘书长"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew70.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">刘 智</b>"+
          "<br />"+
          "珠海市岭南大数据研究院执行院长,清华大学管理硕士"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew71.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">郝晶晶</b>"+
          "<br />"+
          "华为中国区运营商Marketing副部长，华为中国区突出贡献优秀专家"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew72.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">欧阳新志</b>"+
          "<br />"+
          "中兴通讯股份有限公司技术专家委员会成员,中兴5G行业产品线副总经理"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew73.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">周海平</b>"+
          "<br />"+
          "广东城智科技有限公司总经理，珠海华发新科技投资控股有限公司总经理、副董事长"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width: 100%;height:112px; padding-top: 250px; background:url("+require('./assets/img/news/webnew74.jpg')+") center 0 no-repeat;\">"+
          "<p style=\"margin: 5px 20px; padding-left: 20px; line-height: 1.5;\">"+
          "<b style=\"font-size: 18px;color:#7f5ef8;\">陈 伟</b>"+
          "<br />"+
          "珠海华发城市运营投资控股有限公司副董事长，上海华东师范大学学士、上海同济大学工商管理硕士"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:386.66px;float: left;margin-top: 20px; margin-right: 20px;\">"+
          "<div style=\"width:356.66px;height:356px; margin-left: 20px; background:#7f5ef8\">"+
          "<p style=\"margin: 5px 20px; padding-top: 60px; padding-left: 20px;color: #fff; font-size: 18px;\">"+
          "2019年珠海智慧城市专题赛总决赛现场不仅吸引到力合清源等近10家知名投资机构深度参与，评委阵容同样强大，由14位科学家、投资家、企业家、产业专家构成，联袂出场把控赛事评审的整体专业水准、产业前景。"+
          "</p>"+
          "</div>"+
          "</div>"+
          
          "</div>"+
          "</div>"+
          
          
          // "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #433b9f; line-height: 130px;background:url("+require('./assets/img/news/webnew54.jpg')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          // "一站式服务助落地"+
          // "</h2>"+
          
          // "<div style=\"width: 1200px;margin:auto;overflow:hidden;height:500px;background:url("+require('./assets/img/news/webnew60.jpg')+") center 0 no-repeat;\">"+
          // "<div style=\"padding: 60px;\">"+
          // "<p style=\"font-size:18px; margin-bottom: 20px;\">本届比赛于今年4月启动海内外创新项目遴选，6月6日举行新闻发布会，8月2日组织入围赛的专家评审，并甄选出24个总决赛参赛项目。最终获奖的一、二、三等奖六个获奖团队将有机会被推荐进入珠海“英才计划”评审，并结合珠海当地人才、产业、投资环境优势，落地孵化培育，将获得组委会委托单位珠海市岭南大数据研究院提供的客户资源、数据资源及资本对接后续服务。</p>"+
          // "<p style=\"font-size:18px; margin-bottom: 20px;\">据联合主办单位之一——珠海岭南大数据研究院执行院长刘智介绍，本赛事的一个重要特点是把技术、项目、团队和珠海的实际场景关联起来，逐步形成有国际影响力的社会体验、测试和竞赛环境，以一站式服务帮助海内外优秀新技术项目落地珠海。</p>"+
          // "<p style=\"font-size:18px;\">在珠海市工信局的指导下，中国移动广东公司珠海分公司、珠海城智集团、华发公司已经与岭南大数据研究院联合着手规划基于5G技术和运营商数据的园区体验场景搭建。</p>"+
          // "</div>"+
          // "</div>"+
          
          
          
          
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs02.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs03.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs04.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs05.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs06.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_cs07.jpg')+"\" /></div>"+
          "</div>",
          videos:[
            {
              title: "工信局沈岩局长致辞",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/01工信局沈岩局长致辞.mp4",
              thumb: require('./assets/img/c2019/chuangsai_01.jpg')
            },
            {
              title: "珠海（国家）高新区投资环境推介",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/02珠海（国家）高新区投资环境推介.mp4",
              thumb: require('./assets/img/c2019/chuangsai_02.jpg')
            },
            {
              title: "中国移动集团研究院介绍5G联创合作-杨光总经理",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/03中国移动集团研究院介绍5G联创合作-杨光总经理.mp4",
              thumb: require('./assets/img/c2019/chuangsai_03.jpg')
            },
            {
              title: "珠海移动-纳思达-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/04珠海移动-纳思达-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_04.jpg')
            },
            {
              title: "珠海移动-纳思达-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/05珠海移动-纳思达-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_05.jpg')
            },
            {
              title: "中国移动-联想-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/06中国移动-联想-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_06.jpg')
            },
            {
              title: "中国移动-联想-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/07中国移动-联想-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_07.jpg')
            },
            {
              title: "港珠澳大桥-智慧口岸路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/08港珠澳大桥-智慧口岸路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_08.jpg')
            },
            {
              title: "港珠澳大桥-智慧口岸-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/09港珠澳大桥-智慧口岸-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_09.jpg')
            },
            {
              title: "一清科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/10一清科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_10.jpg')
            },
            {
              title: "一清科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/11一清科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_11.jpg')
            },
            {
              title: "珠海港-珠海移动-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/12珠海港-珠海移动-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_12.jpg')
            },
            {
              title: "珠海港-珠海移动-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/13珠海港-珠海移动-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_13.jpg')
            },
            {
              title: "神华粤电-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/14神华粤电-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_14.jpg')
            },
            {
              title: "神华粤电--评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/15神华粤电--评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_15.jpg')
            },
            {
              title: "香港科技大学-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/16香港科技大学-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_16.jpg')
            },
            {
              title: "香港大学-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/17香港大学-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_17.jpg')
            },
            {
              title: "珠海移动-云洲智能-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/18珠海移动-云洲智能-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_18.jpg')
            },
            {
              title: "珠海移动-云洲智能-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/19珠海移动-云洲智能-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_19.jpg')
            },
            {
              title: "欧比特-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/20欧比特-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_20.jpg')
            },
            {
              title: "欧比特-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/21欧比特-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_21.jpg')
            },
            {
              title: "多尼卡-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/22多尼卡-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_22.jpg')
            },
            {
              title: "多尼卡-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/23多尼卡-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_23.jpg')
            },
            {
              title: "广东城智-珠海城建--珠海移动-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/24广东城智-珠海城建--珠海移动-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_24.jpg')
            },
            {
              title: "广东城智-珠海城建--珠海移动-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/25广东城智-珠海城建--珠海移动-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_25.jpg')
            },
            {
              title: "台湾OPUS-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/26台湾OPUS-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_26.jpg')
            },
            {
              title: "台湾OPUS-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/27台湾OPUS-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_27.jpg')
            },
            {
              title: "苗米科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/28苗米科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_28.jpg')
            },
            {
              title: "苗米科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/29苗米科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_29.jpg')
            },
            {
              title: "非普导航科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/30非普导航科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_30.jpg')
            },
            {
              title: "非普导航科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/31非普导航科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_31.jpg')
            },
            {
              title: "上海翼依信息科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/32上海翼依信息科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_32.jpg')
            },
            {
              title: "上海翼依信息科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/33上海翼依信息科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_33.jpg')
            },
            {
              title: "AICRobo隆博科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/34AICRobo隆博科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_34.jpg')
            },
            {
              title: "AICRobo隆博科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/35AICRobo隆博科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_35.jpg')
            },
            {
              title: "生命起点-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/36生命起点-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_36.jpg')
            },
            {
              title: "生命起点-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/37生命起点-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_37.jpg')
            },
            {
              title: "鸿业科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/38鸿业科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_38.jpg')
            },
            {
              title: "鸿业科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/39鸿业科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_39.jpg')
            },
            {
              title: "六邻科技-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/40六邻科技-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_40.jpg')
            },
            {
              title: "六邻科技-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/41六邻科技-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_41.jpg')
            },
            {
              title: "禧涤智能-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/42禧涤智能-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_42.jpg')
            },
            {
              title: "禧涤智能-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/43禧涤智能-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_43.jpg')
            },
            {
              title: "美国Smartenius-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/44美国Smartenius-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_44.jpg')
            },
            {
              title: "美国Smartenius-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/45美国Smartenius-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_45.jpg')
            },
            {
              title: "井智高科-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/46井智高科-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_46.jpg')
            },
            {
              title: "井智高科-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/47井智高科-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_47.jpg')
            },
            {
              title: "汇众时空-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/48汇众时空-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_48.jpg')
            },
            {
              title: "汇众时空-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/49汇众时空-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_49.jpg')
            },
            {
              title: "大地量子-路演",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/50大地量子-路演.mp4",
              thumb: require('./assets/img/c2019/chuangsai_50.jpg')
            },
            {
              title: "大地量子-评委提问",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/51大地量子-评委提问.mp4",
              thumb: require('./assets/img/c2019/chuangsai_51.jpg')
            },
            {
              title: "评委主席讲话",
              link: "https://www.chiefdata.org.cn/video/matchVideo/2019/52评委主席讲话.mp4",
              thumb: require('./assets/img/c2019/chuangsai_52.jpg')
            }
          ],
          datetime:"2019-09-06"
        },
        {
          title:"2018年岭南大数据国际论坛暨创新创业大赛",
          thumb:require('./assets/dataimg/new05.jpg'),
          id:3,
          content:"<div>"+
          "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/img/news/webnew14.jpg')+"\" /></div>"+
          
          
          "<div style=\"width: 1200px;margin:50px auto 0;position:relative;overflow:hidden;\">"+
          "<div style=\"width: 50%;float:left;overflow:hidden;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew15.jpg')+"\" />"+
          "</div>"+
          "<div style=\"width: 50%;float:left;overflow:hidden; padding: 0 20px; box-sizing: border-box;\">"+
          "<p style=\"font-size: 18px;margin-top:10px; text-indent:2em;\">为贯彻国家“国家大数据战略”和“创新驱动发展战略”，响应加快数字化中国建设的战略布局，在珠海高新区管委会指导下，珠海市岭南大数据研究院于2018年9月至12月筹备举办了 “2018岭南大数据国际论坛暨创新创业大赛”系列活动，其中论坛与总决赛赛事于2018年12月8日正式着陆于珠海高新区并成功落幕；通过本次论坛与创新创业大赛系列活动的举办，着力于搭建大数据领域产学研国际交流平台，推动珠海大数据、云计算、人工智能、物联网等产业的发展，提升大数据产业国际辐射能力，聚集优质项目和人才资源，促进大数据应用场景的打造，以及创新思想、创新项目、创新团队和政策资本的深度聚合，吸引全球创新资源落地珠海。</p>"+
          "</div>"+
          "</div>"+
          
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "国际论坛"+
          "</h2>"+
          
          "<div style=\"width: 1200px;margin:50px auto;position:relative;overflow:hidden;\">"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew16.jpg')+"\" />"+
          "<div style=\"margin:30px 30px 0;\">"+
          "<h3 style=\"font-size: 24px; font-weight: 400;position:relative;\">"+
          "梅宏教授"+
          "</h3>"+
          "<p style=\"height:80px; line-height: 40px;\">中国科学院院士</p>"+
          "<p style=\"font-size: 18px;margin-top: 10px; position:relative;\">"+
          "<span style=\"display: inline-block; margin-right: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "主题演讲《打破信息孤岛，盘活数据资源》"+
          "</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew17.jpg')+"\" />"+
          "<div style=\"margin:30px 30px 0;\">"+
          "<h3 style=\"font-size: 24px; font-weight: 400;position:relative;\">"+
          "樊文飞教授"+
          "</h3>"+
          "<p style=\"height:80px; line-height: 40px;\">英国皇家学会院士、欧洲科学院院士<br />爱丁堡皇家学会院士、美国计算机协会会士</p>"+
          "<p style=\"font-size: 18px;margin-top: 10px; position:relative;\">"+
          "<span style=\"display: inline-block; margin-right: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "主题演讲《给小公司提供大数据分析能力》"+
          "</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew18.jpg')+"\" />"+
          "<div style=\"margin:30px 30px 0;\">"+
          "<h3 style=\"font-size: 24px; font-weight: 400;position:relative;\">"+
          "陆永青教授"+
          "</h3>"+
          "<p style=\"height:80px; line-height: 40px;\">英国皇家工程院院士、美国电子电气工程师协会会士<br />英国计算机学会会士</p>"+
          "<p style=\"font-size: 18px; margin-top: 10px;position:relative;\">"+
          "<span style=\"display: inline-block; margin-right: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          "主题演讲《定制计算和智能数据处理》"+
          "</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width: 50%;float:left;overflow:hidden;  margin-bottom: 40px;\">"+
          "<div style=\"margin:0 40px;background-color: #eee; padding-bottom: 30px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew19.jpg')+"\" />"+
          "<div style=\"margin:30px 30px 0;\">"+
          "<h3 style=\"font-size: 24px; font-weight: 400;position:relative;\">"+
          "方开泰教授"+
          "</h3>"+
          "<p style=\"height:80px; line-height: 40px;\">美国数理统计科学院院士<br />美国统计学会院士</p>"+
          "<p style=\"font-size: 18px; margin-top: 10px; position:relative;\">"+
          "<span style=\"display: inline-block; margin-right: 10px;\">"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#ef914d;margin-top:5px;\"></span>"+
          "<span style=\"display: block;height: 5px;width:24px;background-color:#101f4c;margin-top: 6px;margin-left: 10px;\"></span>"+
          "</span>"+
          // "主题演讲《定制计算和智能数据处理》"+
          "</p>"+
          "</div>"+
          "</div>"+
          "</div>"+
          
          
          "</div>"+
          
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "揭牌签约仪式"+
          "</h2>"+
          
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:445px;background:url("+require('./assets/img/news/webnew20.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:100px auto;;position:relative;overflow:hidden;\">"+
          
          "<div style=\"width:25%; float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew21.jpg')+"\" />"+
          "<p style=\"color: #fff;\">珠海市高新区管委会苏虎主任致辞</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:25%;float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew22.jpg')+"\" />"+
          "<p style=\"color: #fff;\">珠海市岭南大数据研究院周路明理事长发表致辞</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:25%;float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew23.jpg')+"\" />"+
          "<p style=\"color: #fff;\">珠海市岭南大数据研究院揭牌仪式</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:25%;float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew24.jpg')+"\" />"+
          "<p style=\"color: #fff;\">珠海市岭南大数据研究院合作单位签约仪式</p>"+
          "</div>"+
          "</div>"+
          
          "</div>"+
          "</div>"+
          
          "<h2 style=\"width: 100%;position:relative;overflow:hidden;height:115px; color: #300d7a; line-height: 130px;background:url("+require('./assets/img/news/webnew04.png')+") center no-repeat; text-align:center;font-size: 36px; font-weight: 400; text-indent:-22px;\">"+
          "国际创赛"+
          "</h2>"+
          
          "<div style=\"width: 100%;position:relative;overflow:hidden;height:445px;background:url("+require('./assets/img/news/webnew25.jpg')+") center no-repeat;\">"+
          "<div style=\"width: 1200px;margin:100px auto;;position:relative;overflow:hidden;\">"+
          
          "<div style=\"width:33.333%; float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew26.jpg')+"\" />"+
          "<p style=\"color: #fff;\">一等奖：碳纳米管柔性材料</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew27.jpg')+"\" />"+
          "<p style=\"color: #fff;\">二等奖：萨摩耶金服、 MarlinDB</p>"+
          "</div>"+
          "</div>"+
          
          "<div style=\"width:33.333%;float: left;\">"+
          "<div style=\"padding: 10px;\">"+
          "<img style=\"width: 100%\" src=\""+require('./assets/img/news/webnew28.jpg')+"\" />"+
          "<p style=\"color: #fff;\">三等奖：智易科技、Spectro Bio新一代传感器技术、极视角</p>"+
          "</div>"+
          "</div>"+
          
          "</div>"+
          "</div>"+
          
          
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_qk02.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_qk03.jpg')+"\" /></div>"+
          // "<div style=\"width: 100%;position:relative;overflow:hidden;\"><img style=\"position:relative;margin-left:-960px;left:50%;\" src=\""+require('./assets/dataimg/new_qk04.jpg')+"\" /></div>"+
          "</div>",
          videos:[
            {
              title: "高新区领导苏虎主任致辞",
              link: "https://www.chiefdata.org.cn/video/matchVideo/苏虎主任.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_01.jpg')
            },
            {
              title: "周路明理事长致辞-基于场景驱动的大数据创新平台",
              link: "https://www.chiefdata.org.cn/video/matchVideo/周路明理事长致辞.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_02.jpg')
            },
            {
              title: "珠海市岭南大数据研究院揭牌仪式",
              link: "https://www.chiefdata.org.cn/video/matchVideo/揭牌仪式.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_03.jpg')
            },
            {
              title: "梅宏院士演讲-打破信息孤岛盘活数据资源",
              link: "https://www.chiefdata.org.cn/video/matchVideo/梅宏院士演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_04.jpg')
            },
            {
              title: "樊文飞院士演讲-给小公司提供大数据分析的能力",
              link: "https://www.chiefdata.org.cn/video/matchVideo/樊文飞院士演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_05.jpg')
            },
            {
              title: "陆永青院士演讲-定制计算和智能数据处理",
              link: "https://www.chiefdata.org.cn/video/matchVideo/陆永青院士演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_06.jpg')
            },
            {
              title: "Jim Davies-Building maps for big data",
              link: "https://www.chiefdata.org.cn/video/matchVideo/jim Davies.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_07.jpg')
            },
            {
              title: "神志雄主任演讲-大数据标准与法规探讨",
              link: "https://www.chiefdata.org.cn/video/matchVideo/神志雄主任演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_08.jpg')
            },
            {
              title: "移动熊勇演讲-蜂巢大数据与智慧城市建设实践",
              link: "https://www.chiefdata.org.cn/video/matchVideo/移动熊勇演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_09.jpg')
            },
            {
              title: "联通宋雨伦演讲-联通大数据挖掘与实践",
              link: "https://www.chiefdata.org.cn/video/matchVideo/联通宋雨伦演讲.mp4",
              thumb: require('./assets/img/f2018/luntan_2018_10.jpg')
            }
          ],
          datetime:"2018-12-08"
        }
      ]
    },
    communication:{
      list: [
        {
          title:"喜报：我院一项成果获得2021地理信息科技进步奖一等奖",
          thumb:require('./assets/img/news/technology/technology1.png'),
          desc: "日前，中国地理信息产业协会公布了2021地理信息科技进步奖评选结果，我院联合北京大学深圳研究生院的一项成果喜获一等奖。",
          id:5,
          content:"<div class=\"main-box\">"+
          "<h2 class=\"text-center\">喜报：我院一项成果获得2021地理信息科技进步奖一等奖</h2>"+
          "<p class=\"text-center\">信息来源： 中国地理信息产业协会官网、北京大学深圳研究生院 &nbsp;&nbsp;&nbsp;&nbsp; 发布时间：2021-11-30</p>"+
          "<div class=\"line\"></div>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;日前，中国地理信息产业协会公布了2021地理信息科技进步奖评选结果，我院联合北京大学深圳研究生院的一项成果喜获一等奖。</p><br>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;中国地理信息产业协会科学技术奖是由国家科学技术奖励工作办公室批准设立的奖项。2021地理信息科技进步奖是根据《地理信息科学技术奖励办法》《地理信息科技进步奖实施细则》，经申报、形式审查、网评、终评，并报地理信息科学技术奖励委员会审定批准，2021地理信息科技进步奖从300多个受理项目中评选出一等奖25项，包括我院参与的“基于大数据的城市个性化宜居分析与服务关键技术及应用”项目。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img style=\"width:80%;\" src=\""+require('./assets/img/news/technology/technology1.png')+"\"><br /></p>"+
          "<p><strong>&nbsp;&nbsp;&nbsp;&nbsp;“基于大数据的城市个性化宜居分析与服务关键技术及应用”</strong></p><br>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;“基于大数据的城市个性化宜居分析与服务关键技术及应用”项目由北京大学深圳研究生院院仝德副教授作为第一完成人，联合哈尔滨工业大学（深圳）、北京大学和珠海市岭南大数据研究院合作开展。本技术聚焦于时空行为大数据、机器学习等社会感知理论方法的个性化宜居分析与服务创新，构建了城市个性化宜居评价指标体系与计算方法，研发了面向个性化需求的宜居地图构建与推荐技术，开发了供城市居民择居择业参考的APP。项目技术已成功应用于宜居城市规划、特色空间营造、空间定制与用户锁定等领域，形成了具有独立知识产权、广泛市场推广前景的技术成果体系。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/img/news/technology/technology2.jpeg')+"\"><p class=\"text-center\" style=\"color:rgb(104, 104, 104);font-size:15px;\">总体技术框架</p><br /></p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/img/news/technology/technology3.jpeg')+"\"><p class=\"text-center\" style=\"color:rgb(104, 104, 104);font-size:15px;\">面向居民个性化需求的城市宜居综合评估框架</p><br /></p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/img/news/technology/technology4.jpeg')+"\"><p class=\"text-center\" style=\"color:rgb(104, 104, 104);font-size:15px;\">行为特征-宜居偏好映射模型与迭代演化</p><br /></p>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;本报道来源于中国地理信息产业协会官网： <a href=\"http://www.cagis.org.cn/Lists/content/id/3366.htmll\">http://www.cagis.org.cn/Lists/content/id/3366.htmll</a></p><br>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;北京大学深圳研究生院-官方微信： <a href=\"https://mp.weixin.qq.com/s/0pDOfs7oFUiZyaTV0U-V9g\">https://mp.weixin.qq.com/s/0pDOfs7oFUiZyaTV0U-V9g</a></p><br>"+
          "</div>",
          datetime:"2021-11-30"
        },
        {
          title:"我院正式加入广东省5G行业应用产业技术创新联盟，携手迈进5G未来",
          thumb:require('./assets/img/news/2021/5g.jpg'),
          desc: "我院正式加入广东省5G行业应用产业技术创新联盟，携手迈进5G未来",
          id:4,
          content:"<div class=\"main-box\">"+
          "<h2 class=\"text-center\">我院正式加入广东省5G行业应用产业技术创新联盟，携手迈进5G未来</h2>"+
          "<p class=\"text-center\">信息来源： 岭南大数据研究院 &nbsp;&nbsp;&nbsp;&nbsp; 发布时间：2021-11-23</p>"+
          "<div class=\"line\"></div>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;11月22日，珠海市岭南大数据研究院正式加入广东省5G行业应用产业技术创新联盟成为其中一员。作为新型研发机构，一直以“面向产业关键技术的前沿研究”为宗旨，依托广东移动等运营商海量数据资源和自身体制机制的独特优势，致力于建设以珠海为基础的城市级大数据应用创新试验场，打造城市级大数据体验场景。</p>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;此次加入广东省5G行业应用产业技术创新联盟将本着资源共享、优势互补的原则，向5G领域及5G应用行业领域的企业和机构提供技术、标准和解决方案等产业公共服务，携手各方力量开展协同创新，积极助推5G行业应用的发展。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/img/news/2021/BDI.jpg')+"\"><br /></p>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;广东省5G行业应用产业技术创新联盟是在广东省科技厅推动下，由广东省新一代通信与网络创新研究院会同行业应用龙头企业和机构、运营商和设备商等30家单位共同发起的产学研合作平台，旨在统筹整合广东省5G行业应用各方力量，加快推动5G行业应用技术创新、标准制定和示范应用。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/img/news/2021/5g.jpg')+"\"><br /></p>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;联盟重点开展四项工作：一是整合5G行业应用的创新资源与产业资源，形成推进5G行业应用的多方合力。二是研究制定典型行业应用5G网络的标准体系，制定发布地方标准或团体标准，推动形成国家或行业标准。三是针对当前5G行业应用仍面临的技术瓶颈，推动形成可复制、可推广的5G行业应用解决方案。四是推动创新链、产业链与资金链的有效融合，引入社会资本助推5G行业应用。</p>"+
          "<p><strong>&nbsp;&nbsp;&nbsp;&nbsp;联盟联合发起单位（以单位名称拼音顺序排列）:</strong></p><ul><li>宝武集团广东韶关钢铁有限公司</li><li>广东电网有限责任公司</li><li>广东科学中心</li><li>广东省标准化研究院</li><li>广东省机场管理集团有限公司</li><li>广东省疾病预防控制中心</li><li>广东省教育研究院</li><li>广东省气象探测数据中心</li><li>广东省人民医院</li><li>广东省水利水电科学研究院</li><li>广东省新一代通信与网络创新研究院</li><li>广州地铁集团有限公司</li><li>广州港集团有限公司</li><li>广州广电运通金融电子股份有限公司</li><li>广州海格通信集团股份有限公司</li><li>广州明珞汽车装备有限公司</li><li>广州汽车集团股份有限公司</li><li>广州市市政集团有限公司</li><li>华润燃气控股有限公司</li><li>华为技术有限公司</li><li>清远天安智谷有限公司</li><li>全国海关信息中心广东分中心</li><li>粤港澳5G应用创新中心</li><li>中广核研究院有限公司</li><li>中国电信股份有限公司广东分公司</li><li>中国联合网络通信有限公司广东省分公司</li><li>中国移动通信集团广东有限公司</li><li>中国石化股份有限公司广州分公司</li><li>中山大学附属第一医院</li><li>中兴通讯股份有限公司</li></ul>"+
          "<p>&nbsp;&nbsp;&nbsp;&nbsp;我院未来将携手广东省5G行业应用产业技术创新联盟，继续围绕数字经济产业应用需求及技术瓶颈，积极开展关键技术攻关研究，引进孵化优质项目团队，发展成为粤港澳大湾区科研产业化的一颗璀璨明珠。</p>"+
          "</div>",
          datetime:"2021-11-23"
        },
        {
          title:"人工智能“芯”科技国际学术交流会院士讲坛",
          thumb:require('./assets/dataimg/new101.jpg'),
          desc: "7月29日上午，2019人工智能“芯”科技国际学术交流会在珠海市成功着陆。",
          id:3,
          content:"<div class=\"main-box\">"+
          "<h2 class=\"text-center\">人工智能“芯”科技国际学术交流会院士讲坛</h2>"+
          "<p class=\"text-center\">信息来源： 岭南大数据研究院 &nbsp;&nbsp;&nbsp;&nbsp; 发布时间：2019-07-29</p>"+
          "<div class=\"line\"></div>"+
          "<p>7月29日上午，2019人工智能“芯”科技国际学术交流会在珠海市成功着陆。</p>"+
          "<p>珠海市科学技术协会刘治民主席、科技创新局伞景辉副局长、珠海市岭南大数据研究院周路明理事长出席并致辞。珠海市高新区科产局扶志局长、珠海市高新区双创中心郁李毅主任及珠海市岭南大数据研究院刘智院长、珠海市科协学会部赖兵部长出席了开幕仪式。</p>"+
          "<p>本次暑期学校活动邀请了定制计算领域国际权威、英国工程院院士、伦敦帝国理工学院教授Wayne Luk陆永青院士，基于闪存的集成电路设计领域专家、悉尼大学电气与信息工程学院副院长Philip Leong教授，FPGA研究领域著名学者、LegUp Computing公司创始人之一、多伦多大学电子与计算机系教授Jason Anderson，以及加拿大滑铁卢大学助理教授Nachiket Kapre，就FPFA加速技术在神经网络与AI深入学习、应用程序开发平台以及领域特定设计等内容做主题演讲。</p>"+
          "<p>经过遴选，来自帝国理工学院、香港城市大学、北京航空航天大学、中科院、清华大学、复旦大学、哈尔滨工业大学、悉尼大学以及多伦多大学等国内外知名高校的数十位相关领域博士生、研究生、优秀本科毕业生以及专业工程师参加了这次的培训课程。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new1.jpg')+"\"><br />图：珠海市科学技术协会刘治民主席致辞 </p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new2.jpg')+"\"><br />图：珠海市科创局伞景辉副局长致辞 </p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new3.jpg')+"\"><br />图：珠海市高新区科产局扶志局长出席开幕式 </p>"+
          "<p><b>珠海市科协刘治民主席表示：</b></p>"+
          "<p>作为珠海市科学技术工作者的群众组织，珠海市科协一直致力于营造良好学术氛围，支持高端学术交流活动举办。</p>"+
          "<p>今年6月市科协发布了《珠海市高端学术交流资助办法（试行）》，旨在大幅度支持由我市学术团体、科研机构、高等院校、科技型创新企业等科技类创新机构举办具有国际影响的科技及产业发展高端学术交流活动。</p>"+
          "<p>此次人工智能“芯”科技国际交流会在珠海的举办如同一场“及时雨”，期望今天在场的国际专家多关注珠海人工智能产业发展，多为珠海推荐人工智能产业领域的高端人才。</p>"+
          "<p><b>珠海市科创局伞景辉副局长表示：</b></p>"+
          "<p>肯定了主办方珠海市岭南大数据研究院作为民非企业，在成立的一年多时间内策划与组织的数场大型极具影响力的学术交流活动，极大地促进了珠海科技创新与大数据产业的发展。</p>"+
          "<p>希望有更多地科创载体一起加入来丰富科技创新体系，推动产业创新升级，并对陆院士携人工智能领域全球高水准专家抵达珠海指导，开设讲座表示欢迎和感谢。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new4.jpg')+"\"><br />图：陆永青院士主持 </p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new5.jpg')+"\"><br />图：珠海市岭南大数据研究院周路明理事长致辞</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new6.jpg')+"\"><br />图：珠海市岭南大数据研究院刘智院长出席开幕式</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new7.jpg')+"\"><br />图：开幕式现场</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new8.jpg')+"\"><br />图：开幕式现场</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new9.jpg')+"\"><br />图：海内外知名教授</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new101.jpg')+"\"><br />图：2019年AI夏校师生合影</p>"+
          // "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new102.jpg')+"\"><br />图：“打卡珠海地标：珠海大剧院 日月贝”</p>"+
          "<p>开幕式结束后，珠海市科学技术协会刘治民主席、珠海市高新区双创中心郁李毅主任及珠海市岭南大数据研究院刘智院长、珠海市科协学会部赖兵部长等一行来我院参观交流。</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new103.jpg')+"\"><br />图：市领导参观照</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new104.jpg')+"\"><br />图：市领导与研究院领导交流照</p>"+
          "<p class=\"text-center\" style=\"margin:15px 0;\"><img src=\""+require('./assets/dataimg/new105.jpg')+"\"><br />图：市领导与研究院领导合影</p>"+
          "<p>此次暑期学校由鲲云人工智能应用创新研究院、鲲云科技以及珠海岭南大数据研究院主办，英特尔作为合作伙伴，共同组织此次活动。活动历时5天（2019年7月29日至8月2日），4位全球知名人工智能领域学术大咖坐镇讲台，来自帝国理工、北大、清华、复旦、中科院、上海科技大学、澳门科技大学等全球21所知名高校人工智能领域内的硕、博士人才踊跃参加，依托于珠海市岭南大数据研究院人工智能实验室平台资源和环境，聚焦于计算加速器的结构、工具、开发方法及其应用等人工智能前沿学科研究领域，就FPGA加速技术知识展开深入讨论。</p>"+
          "<p>这是人工智能“芯”科技领域国际学术交流会首次在珠海举办，这场活动将进一步促进人工智能国际创新资源在珠海聚集，对湾区内的高端人才培养具有前瞻意义和影响。</p>"+
          "</div>",
          datetime:"2019-07-29"
        },
       
      ]
    }
  },
  "en":{
    salon:{
      list:[
        {
          title:"Research Workshop Series 2020",
          thumb:require('./assets/dataimg/new-salon-2thumb_en.png'),
          desc: 'On August 25, 2020, under the guidance of the Zhuhai National Hi-Tech Industrial Development District and hosted by Lingnan Big Data Research Institute, the Research Workshop Series 2020  was held. With the theme of "Digital Technology Empowers Smart Parks", guests discussed the future and development of smart parks together. The digital industry brain construction, three-dimensional visualization development, smart security, industrial chain framework construction, enterprise intelligence platform, and other applications and technologies were also discussed in this workshop deeply. The current situation and trends of smart park construction were also included in this topic, varieties of constructive ideas, on solving existing obstacles were brought up as well.',
          id:2,
          datetime:"2020-8-25"
        },
        {
          title:"Blockchain Seminar",
          thumb:require('./assets/dataimg/new01_en.png'),
          desc: 'On November 22, 2019,  Lingnan Big Data Research Institute hosted the Zhuhai International Seminar on Blockchain and Information Security. This seminar brought together authoritative experts, well-known scholars, and senior entrepreneurs from government, industry, academia, and research to discuss the innovative application of blockchain technology in the field of big data. It also provided a platform for the exchange of theoretical and technological achievements for scholars and technicians at home and abroad in the fields of blockchain, information security, and big data.',
          id:1,
          datetime:"2019-11-22"
        }
      ]
    },
    forum:{
      list:[
        {
          title:"2019 Forum and Contest",
          thumb:require('./assets/dataimg/new04_en.png'),
          desc: 'From September 6th to 7th, 2019, the 5G Application Contest of the MIIT-Zhuhai Smart City and the 2nd Lingnan Big Data International Forum were held. The event attracted 24 teams with strong technical ability and originality. 15 projects have received financial support from investment institutions, 13 projects have completed more than two rounds of funding. Several achievements were released during the "Zhuhai Smart City Achievements Release" section of the international forum.<br />In addition，the Faculty of Information Technology of Macau University of Science and Technology and Zhuhai Lingnan Big Data Research Institute signed a contract to establish the "Zhuhai-Macao Joint Research Center for Intelligent Interconnection and Computing".',
          id:1,
          datetime:"2019-09-07"
        },
        {
          title:"2018 Forum and Contest",
          thumb:require('./assets/dataimg/new05_en.png'),
          desc: 'On December 8, 2018, Lingnan Big Data Research Institute organized the "2018 Lingnan Big Data International Forum and Innovation and Entrepreneurship Competition". This event built an international exchange platform for industry, academia and research in the field of big data, promoting the development of big data, cloud computing, AI, and IoT in Zhuhai. ',
          id:3,
          datetime:"2018-12-08"
        }
      ]
    },
    communication:{
      list: [
        {
          title:"AI Summer Course",
          thumb:require('./assets/dataimg/new101_en.jpg'),
          desc: "From July 29 to August 2, 2019, Summer Course in Artificial Intelligence was held in Zhuhai for the first time.<br />World-renowned academic experts in the field of artificial intelligence were invited to give keynote speeches at the events. Masters and Ph.D. talents from 21 well-known universities around the world in the field of artificial intelligence actively participated. On the basis of the resources and environment of BDI's AI lab, the Summer Course focuses on frontier research in the field of AI,  such as the structure, tools, development methods, and applications of computing accelerators. Speakers and audience had in-depth discussions about FPGA acceleration technology. ",
          id:3,
          datetime:"2019-07-29"
        },
      ]
    }
  }
}


//关于我们
export const about = {
  "zh-CN":{
    brief:{
      data:"<div style=\"text-align:center;\"><img style=\"width:800px;\" src=\""+require('./assets/dataimg/data5.png')+"\" /></div>"+
      "<p style=\"text-indent:2em;\">珠海市岭南大数据研究院是一家由珠海高新区管委会发起设立的非盈利新型科研机构，成立于2018年4月。</p>"+
      // "<div style=\"text-align:center;\"><img style=\"width:100%;\" src=\""+require('./assets/dataimg/about01.jpg')+"\" /></div>"+
      "<p style=\"text-indent:2em;\">研究院与国内外知名高校合作，通过引进大数据和人工智能领域顶尖人才，致力于开展政府各部门数据、运营商数据及园区企业数据的融合研究、数据安全研究，打造城市级大数据体验场景。在政府管理、社会治理、企业创新等应用领域，通过大数据技术为组织赋能，推动组织运作的变革和创新。</p>"+
      "<p style=\"text-indent:2em;\">研究院以“面向产业关键技术的前沿研究”为宗旨，设立“智能驾驶”、“大数据”、“人工智能”、“智能感知”四大研究中心，下设“智能驾驶与大数据”、“数字孪生”、“区块链与大数据”、“时空大数据与人工智能”、“医疗大数据与人工智能”、“物联网与大数据”、“交通大数据分析及应用”实验室。</p>"+
      "<p style=\"text-indent:2em;\">2019年，依托珠海市岭南大数据研究院设立珠海市市级新型研发机构。</p>"+
      "<p style=\"text-indent:2em;\">2020年，依托珠海市岭南大数据研究院设立市级工程技术研究中心-珠海市大数据工程技术研究中心。</p>"+
      "<p style=\"text-indent:2em;\">2021年11月，珠海市岭南大数据研究院正式加入广东省5G行业应用产业技术创新联盟成为其中一员。</p>"+
      "<div style=\"text-align:center;margin-top: 20px;\"><img style=\"width:100%;\" src=\""+require('./assets/img/about03.jpg')+"\" /></div>"
    },
    introduce:{
      data:"<div class=\"clearfix\" style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/zh-CN/research/dataCenter\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_dashuju.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_dashuju.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "大数据研究中心"+
      "</p>"+
      "<p>大数据研究中心融合移动运营商大数据、政务大数据、互联网大数据资源优势，围绕珠海市及粤港澳大湾区的数字经济产业应用需求，开展大数据应用创新、多源数据融合及数据计算加速等相关方面的研究。大数据研究中心下设物联网与大数据实验室、区块链与大数据实验室、时空大数据与人工智能实验室、交通大数据分析及应用实验室。</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"zh-CN/research/drive\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_zinengjias.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_jiashi.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "智能驾驶研究中心"+
      "</p>"+
      "<p>智能驾驶研究中心致力于建设粤港澳大湾区智能驾驶系统科创平台，为产业界提供成熟的智能驾驶系统整体解决方案。主要围绕无人驾驶感知、导航、规划决策、深度学习、数据集等开展理论与应用研究，实现智能驾驶技术和产品等方面的研发、应用和推广。智能驾驶研究中心下设智能驾驶与大数据实验室、数字孪生实验室。</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/zh-CN/research/artificial\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_rgzn.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_ganzhi.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "人工智能研究中心"+
      "</p>"+
      "<p>人工智能研究中心面向新一代人工智能技术和应用的研究前沿，旨在推进人工智能平台底层软硬件技术及与不同学科的交叉方向研究，培育拥有自主知识产权的人工智能生态系统。</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/zh-CN/research/perception\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_zngz.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_shou.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "智能感知研究中心"+
      "</p>"+
      // "<p>智能感知研究中心致力于研发先进的智能感知技术，围绕从新型传感芯片和新型传感器技术，建立智能传感创新技术的应用研究平台，重点研发技术主要包括：智能传感器技术、无线感知网络、智能感知技术，为大数据、人工智能等新兴领域提供技术支持。智能感知研究领域下设智能互联与计算联合研究实验室。</p>"+
      "<p>筹备中，敬请期待...</p>"+
      "</div>"+
      "</a>"+
      "</div>"
    },
    contact:{
      data:"<div style=\"overflow:hidden;\">"+
      "<div style=\"width:50%; float:left;\">"+
      "<img style=\"margin-left: 80px;height:128px;\" src=\""+require('./assets/dataimg/data6.png')+"\" />"+
      "</div>"+
      "<div style=\"width:50%; float:left; font-size: 16px;\">"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">L:</span> 珠海市香洲区港湾一号湾11栋五层</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">T:</span> +86 0756 6348393</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">E:</span> wisdom@chiefdata.org</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">W:</span> www.chiefdata.org.cn</p>"+
      "</div>"+
      "</div>"+
      "<div style=\"height:1px;background-color:#ccc;width:100%;margin:30px 0;\"></div>"+
      "<img style=\"width:100%;\" src=\""+require('./assets/dataimg/about02.jpg')+"\" />"+
      "<div>"+
      "<iframe style=\"width:100%;height:500px;border: 0;margin-top:40px;\" src=\"https://www.amap.com/search?id=B0FFJE5CTA&city=440402&geoobj=116.279777%7C40.140924%7C116.290077%7C40.14546&query_type=IDQ&query=%E7%8F%A0%E6%B5%B7%E5%B8%82%E5%B2%AD%E5%8D%97%E5%A4%A7%E6%95%B0%E6%8D%AE%E7%A0%94%E7%A9%B6%E9%99%A2&zoom=17\"></iframe>"+
      "</div>"
    }
  },
  "en":{
    brief:{
      data:"<div style=\"text-align:center;\"><img style=\"width:800px;\" src=\""+require('./assets/dataimg/data5_en.png')+"\" /></div>"+
      "<p style=\"text-indent:2em;\">Zhuhai Big Data Institute (BDI) was founded in April 2018 as a non-profit research organization and sponsored by Zhuhai Government. BDI for research on innovation and science has brought worldwide famous scientists, researchers and top talents from different higher education institutions and organizations in Artificial Intelligence, Big Data areas. In August 2019, we have been recognized as a key innovation research institute in Zhuhai and participate the research through variety fields including data fusion, cybersecurity and data application studies in government management, industry operation as well as innovative products development. </p>"+
      // "<div style=\"text-align:center;\"><img style=\"width:100%;\" src=\""+require('./assets/dataimg/about01.jpg')+"\" /></div>"+
      "<p style=\"text-indent:2em;\">BDI aims cutting-edge research on key industry technologies and set four research centers, containing Autonomous Driving center, Big Data center, Artificial Intelligence center, and IntelliSense center. The projects are carried out in many laboratories, for example autonomous driving laboratory, digital twin laboratory, block chain laboratory, healthcare big data & AI laboratory, transportation big data analysis laboratory and so on. BDI also plays a crucial role in research and application. As a scientific research platform, we serve clients from diverse segments of government and industry to build different 5G applications. As a connector, we collaborate with governments, industries and end users to promote the 5G applications vertical development in commercial field. </p>"+
      "<p style=\"text-indent:2em;\">BDI builds an incubation center to industrialize scientific findings of research centers and bring jumpstarting businesses or high-developed entrepreneurs in Zhuhai. We have accelerated many high-developed innovative businesses, i.e. Shenzhen Unity-Drive Innovation Technology Co., Ltd, Corerain and so on. In the future, BDI will keep incubating or bringing unicorn, top businesses and high developed entrepreneurs into Zhuhai and continue with combination of the entrepreneurial spirit, creative community and innovative mindset in autonomous driving, big data, artificial intelligence and intellisense areas.</p>"+
      "<div style=\"text-align:center;margin-top: 20px;\"><img style=\"width:100%;\" src=\""+require('./assets/img/about03.jpg')+"\" /></div>"
    },
    introduce:{
      data:"<div class=\"clearfix\" style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/en/research/dataCenter\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_dashuju.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_dashuju.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "Big Data Research Center"+
      "</p>"+
      "<p>Integrating data from mobile operators, government and the Internet, the Big Data Research Center focuses on the application of digital economy in Zhuhai and the Greater Bay Area. The Center carries out researches on big data innovative applications innovation, multi-source data fusion and data compute acceleration. The Big Data Research Center consists of IoT and Big Data Lab, Blockchain and Big Data Lab, Spatiotemporal Big Data and AI Lab, as well as Traffic Big Data Analysis and Application Lab.</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/en/research/drive\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_zinengjias.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_jiashi.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "Autonomous Driving Research Center"+
      "</p>"+
      "<p>The Autonomous Driving Research Center is  dedicated to building a technology innovation platform for autonomous driving systems in the Guangdong-Hong Kong-Macao Greater Bay Area, to provide a mature autonomous driving system solution. It mainly focuses on carrying out theoretical and applied research based on auto-driving , navigation, planning, decision-making, deep learning, data sets, etc.，while realizing the research development, application, and promotion of autonomous driving technology and products at the same time.</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/en/research/artificial\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_rgzn.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_ganzhi.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "AI Research Center"+
      "</p>"+
      "<p>Aiming at the frontiers of the new generation of artificial intelligence technology and applications, the Artificial Intelligence Research Center aims to promote the research of the underlying software and hardware technologies of the artificial intelligence platform and the cross-direction of different disciplines, and cultivate an artificial intelligence ecosystem with independent intellectual property rights.</p>"+
      "</div>"+
      "</a>"+
      "</div>"+
      "<div style=\"border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin-top:-1px;overflow:hidden;padding: 40px 0;\">"+
      "<a class=\"a-link\" href=\"/en/research/perception\">"+
      "<div class=\"a-thumb\" style=\"float:left;width:500px;\">"+
      "<img style=\"width:500px;height: 320px;\" src=\""+require('./assets/img/02kyzx_zngz.png')+"\" />"+
      "</div>"+
      "<div style=\"width:600px; float:left; line-height:1.8;padding:0 50px;\">"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;\">"+
      "<img style=\"width:80px;\" src=\""+require('./assets/img/index_keyan_icon_shou.png')+"\" />"+
      "</p>"+
      "<p style=\"width:100%;text-align:center;font-size: 24px;margin:0;\">"+
      "Intelligence Recognition Research Center"+
      "</p>"+
      // "<p>智能感知研究中心致力于研发先进的智能感知技术，围绕从新型传感芯片和新型传感器技术，建立智能传感创新技术的应用研究平台，重点研发技术主要包括：智能传感器技术、无线感知网络、智能感知技术，为大数据、人工智能等新兴领域提供技术支持。智能感知研究领域下设智能互联与计算联合研究实验室。</p>"+
      "<p>Coming soon...</p>"+
      "</div>"+
      "</a>"+
      "</div>"
    },
    contact:{
      data:"<div style=\"overflow:hidden;\">"+
      "<div style=\"width:50%; float:left;\">"+
      "<img style=\"margin-left: 80px;height:128px;\" src=\""+require('./assets/dataimg/data6.png')+"\" />"+
      "</div>"+
      "<div style=\"width:50%; float:left; font-size: 16px;\">"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">L:</span> 5F, Bldg Wan 11, Tech Bay, High Tech Industrial Development District, Zhuhai</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">T:</span> +86 0756 6348393</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">E:</span> wisdom@chiefdata.org</p>"+
      "<p style=\"margin:0;\"><span style=\"display:inline-block;width: 30px; text-align:right;\">W:</span> www.chiefdata.org.cn</p>"+
      "</div>"+
      "</div>"+
      "<div style=\"height:1px;background-color:#ccc;width:100%;margin:30px 0;\"></div>"+
      "<img style=\"width:100%;\" src=\""+require('./assets/dataimg/about02_en.jpg')+"\" />"+
      "<div>"+
      "<iframe style=\"width:100%;height:500px;border: 0;margin-top:40px;\" src=\"https://www.amap.com/search?id=B0FFJE5CTA&city=440402&geoobj=116.279777%7C40.140924%7C116.290077%7C40.14546&query_type=IDQ&query=%E7%8F%A0%E6%B5%B7%E5%B8%82%E5%B2%AD%E5%8D%97%E5%A4%A7%E6%95%B0%E6%8D%AE%E7%A0%94%E7%A9%B6%E9%99%A2&zoom=17\"></iframe>"+
      "</div>"
    }
  }
}

//加入我们
export const join = {
  "zh-CN":{
    data:[
      {
        name:"科研部",
        id:1,
        child:[
          {
            name:"科研部副总监",
            workExp:"3-5年",
            id:101,
            data:{
              education:"硕士及以上" ,//学历
              workExp:"3-5年",
              salary:"20-35k",
              duty:[
                "1、组织收集、分析与研究院相关的政策文件及最新政策动态，选择适合申报的各类产品的项目申报信息；组织申请研究院各类扶持资金，包括政府支持专项资金、创新资金、科研资金；",
                "2、组织并负责对申报项目进行可行性分析、推进意见及前期准备；协助部门领导解决项目申报中需要与政府部门沟通及协调事项；",
                "3、维护研究院横向/纵向课题相关合作单位长期稳定合作关系，拓展科研合作资源。"],
              requirement:[
                "1、3-5年工作经历；",
                "2、硕士（含）以上学历，工科类专业优先；",
                "3、2年以上科研项目申报和组织管理工作经验，具有高校和科研院所工作经历优先；",
                "4、较强的组织协调能力与执行能力；",
                "5、具有良好团队合作精神和内部组织管理能力。"
              ]
            }
          },
          {
            name:"大数据研究员",
            workExp:"2年以上",
            id:102,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"13-18k",
              duty:[
                "1、负责新兴大数据技术的理论方法、核心技术及应用技术的研究，并形成相关研究报告；",
                "2、针对不同的科研业务需求，形成面向政府/行业的大数据解决方案；",
                "3、负责大数据相关技术规划、标准研究；",
                "4、负责大数据相关课题申报及研究工作。"
              ],
              requirement:[
                "1、计算机、数学相关专业，全日制本科及以上学历；",
                "2、2年以上工作经验；",
                "3、具有较强的数据挖掘、机器学习、语义分析的理论基础和实际项目经验，精通数据分析与各种算法与模型；构建用户画像分析体系；",
                "4、精通Hadoop／Spark、Hive、HBase等主流的大数据技术，有产品／平台项目研发经验者优先；具备大型复杂Hadoop数据平台的建设实施经验；精通Java及Python。"
              ]
            }
          },
//           {
//             name:"项目经理",
//             workExp:"1年以上",
//             id:103,
//             data:{
//               education:"本科以上" ,//学历
//               workExp:"1年以上",
//               salary:"20-30k",
//               duty:[
//                 "1、组织申请研究院各类扶持资金，包括政府支持专项资金、创新资金、科研资金、奖励资金、资质申请、资源申请、知识产权的申请与保护、人才资质等所有项目的申请和文件编制的工作； ",
//                 "2、负责收集、分析与研究院相关的政策文件及最新政策动态，选择适合申报的各类产品的项目申报信息；",
//                 "3、规划研究院全年项目申报计划、对申报项目进行可行性分析、推进意见及前期准备；",
//                 "4、协调研究院内部相关部门准备和收集文档资料，参与编制、撰写、修改、整理申报材料；"
//  ,
//                 "5、整理项目申报、批复文件等相关数据，文档数据录入，项目维护和实施网上申报等；",
//                 "6、组织协调并整合研究院资源，参与项目的立项、申报、审批、验收等各环节工作，负责申报材料的送审、公关执行、过程跟踪，直至项目验收完成；",
//                 "7、按照国家、省、市级、区科技局相关文件要求撰写材料，协助部门领导解决项目申报中需要与政府部门沟通及协调事项；",
//                 "8、负责组织软件著作权、专利、高新技术企业、质量管理体系等企业知识产权相关文件的撰写和申报、验收等工作；",
//                 "9、建立和维护与政府部门的长期稳定合作关系，为研究院争取有利资源。"             ],
//               requirement:[
//                 "1、计算机、数学、自动化、电子信息工程、新闻传媒等相关专业本科以上学历；",
//                 "2、责任心强，性格开朗，具有活动组织、学生会工作经历者优先；",
//                 "3、要有科研项目申报经验，主管负责过本单位的科研立项的工作经验1年以上；",
//                 "4、具有较好的语言沟通能力与团队合作精神，具有极强的学习能力、写作能力；",
//                 "5、具有互联网、通信行业研发和工作经验，有相关科研项目申报经验优先。"
//               ]
//             }
//           }
        ]
      },
      {
        name:"综合部",
        id:2,
        child:[
          {
            name:"人力资源高级经理",
            workExp:"8年以上",
            id:201,
            data:{
              education:"硕士及以上" ,//学历
              workExp:"8年以上",
              salary:"13-18k",
              duty:[
                "1、负责人力资源部整体管理，组织达成相关工作目标；",
                "2、根据研究院总体发展战略目标，制订研究院人力资源战略发展规划；",
                "3、主导研究院组织架构及岗位设计、评价及完善工作，组织各岗位工作分析和人员定岗定编；",
                "4、主导组织建立和完善研究院的人力资源管控体系；",
                "5、主导研究院年度的培训计划的审定与控制，对培训预算，培训计划的落实进行日常的监督与管理；","6、主导制定和修订研究院各项绩效考核制度、先进评选方案，并督导相关人员执行；","7、主导制定和修订研究院薪酬福利制度、设计薪酬体系、编制薪资方案及福利计划，并督导相关人员执行；","8、向研究院高层决策者提供有关人力资源战略、组织建设等方面的建议，并致力于提高研究院的人力管理水平。"
              ],
              requirement:[
                "知识与经验要求",
                "1、全日制大学硕士及以上学历，人力资源及管理类专业优先；",
                "2、8年以上人力资源管理经验，3年以上人力资源高级经理或总监团队管理经验；",
                "3、了解现代企业人力资源管理模式和实践经验积累，对人力资源管理各个职能模块均有较深入的认识；",
                "4、熟悉国家相关的政策、法律法规。",
                "综合素质要求",
 "1、积极进取，具备很强的责任心、上进心和事业心；","2、富有热情，坚韧不拔，抗压力强；","3、具有良好的职业道德，能摒弃个人私利和偏见，依据原则、标准和事实看待和处理人和事；","4、具备良好的人际交往能力、组织协调能力、沟通能力以及解决复杂问题的能力。"           ]
            }
          }
        ]
      },
      {
        name:"业务部",
        id:3,
        child:[
          {
            name:"技术经理",
            workExp:"5年以上",
            id:302,
            data:{
              education:"本科以上" ,//学历
              workExp:"5年以上",
              salary:"15-25k",
              duty:[
                "1、根据项目具体要求，承担技术管理角色，按计划完成任务目标；",
                "2、参与需求分析、系统设计，并负责完成系统的技术架构设计与核心模块代码编写工作；",
                "3、有关技术方案、文档的编写，研发管理规范的制定与落地执行工作；",
                "4、负责搭建和维护核心IT资源和硬件等。"
              ],
              requirement:[
                "1、5年以上Java开发经验，2年以上大型系统技术架构经验，2年以上项目管理经验；",
                "2、熟悉Java开源框架，如SpringBoot、微服务应用等，熟悉J2EE规范，熟悉Tomcat、Jetty等开源服务器；",
                "3、具体一定的网络、服务器管理经验，熟悉Linux下的常用命令，熟练掌握网络基础架构知识，了解各种网络协议及其原理应用，有一定的网络架构应用经验优先；",
                "4、熟悉服务器虚拟化技术、分布式存储架构技术，有一定的虚拟化、集群架构应用经验；",
                "5、熟练掌握MySQL、Nosql等数据库相关的技术，有海量大数据应用架构经验者优先；"
 ,  "6、熟悉常用设计模式、设计工具，熟悉高并发、高负载、高可用性系统设计的设计开发及调优；"
 ,"7、具有良好的沟通能力，对技术有激情，喜欢钻研，能快速接受和掌握新技术，有较强的独立、主动的学习能力。"
            ]
            }
          },
          {
            name:"算法工程师",
            workExp:"2年以上",
            id:304,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"16-20k",
              duty:[
                "1、负责相关数据业务分析、大数据分析和数据挖掘；",
                "2、负责大数据的处理、整合及数据建模，协同业务开发人员，将模型算法成果应用到实际业务系统中，并通过可视化工具进行分析成果展示；",
                "3、负责根据实际业务要求，完成较深入的专项数据分析并形成分析报告；",
                "4、负责大数据模型、业务的相关算法的研究及应用；"
 ,
                "5、负责在客户现场进行需求调研，收集分析资料。"
              ],
              requirement:[
                "1、本科及以上学历，计算机、大数据、数据挖掘、机器学习、统计、数学等相关专业；",
                "2、具备良好的数学，统计学基础，对数据敏感，逻辑性强；",
                "3、具备良好的沟通能力，有工作激情、团队协作精神，可以承受较强的工作压力；",
                "4、熟练使用一种以上数据分析建模软件( 如Python、R、MATLAB等），有计算机相关专业基础；",
                "5、具有海量数据挖掘及分析相关项目经验，具有互联网行业、政府行业分析挖掘经验、文本挖掘经验优先，了解运营商数据优先；"
 ,
                "6、2年及以上工作经历，有电信运营商、政府及其他相关大数据项目工作经历优先。"
             ]
            }
          },
          {
            name:"大数据开发工程师",
            workExp:"2年以上",
            id:305,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"10-20k",
              duty:[
                "1、开展基于海量大数据分析处理挖掘工作；",
                "2、承担大数据需求问题的优化/规划设计工作，参与大数据算法研究、数据分析和应用开发等工作；",
                "3、对基于需求问题的分析、设计、实现能够提出独到的见解和思考；能够基于问题提出对应的解决模型（算法）；",
                "4、参与相关产品线与项目的实施工作。"
              ],
              requirement:[
                "1、计算机类相关专业，本科及以上学历，硕士/博士学历优先；",
                "2、具有2年以上大数据应用领域内工作经验者优先；",
                "3、具备较强的开发能力，熟悉Java/Python等数据分析语言及相关库应用者；",
                "4、熟悉MySQL/Hive等数据库，有大数据开发经验，熟悉信息采集与数据分析经验者优先；"
,
                "5、工作主动、有计划，具有良好的沟通理解能力，良好的团队合作精神和保密意识；"
 
,
                "6、具备良好的抗压能力，对技术和业务难题富有钻研精神。"
               ]
            }
          },
//           {
//             name:"大数据分析师",
//             workExp:"2年以上",
//             id:306,
//             data:{
//               education:"硕本科及以上" ,//学历
//               workExp:"2年以上",
//               salary:"9-15k",
//               duty:[
//                 "1、参与研究院大数据产品规划,大数据处理分析平台的设计；",
//                 "2、参与设计数据系统的数据层，根据业务需求进行数据报表相关的研发工作；",
//                 "3、负责数据分析、加工、清理、处理程序的开发；",
//                 "4、负责基于Hadoop/Spark/Hive/Kafka等分布式计算平台实现离线分析、实时分析的应用开发；",
//                 "5、负责数据架构设计及前端数据应用开发工作；",
//                 "6、负责大数据的处理和分析工作、大数据平台展现层的研发工作。"            ],
//               requirement:[
//                 "1、大学本科以上学历，2年以上大数据开发经验；",
//                 "2、熟悉Java、Scala、Python语言、熟悉常用设计模式、具有代码重构意识；",
//                 "3、熟练使用Hadoop、Hbase、Kafka、Hive、Spark、Presto、Kylin、Flink,熟悉底层框架和实现原理；",
//                 "4、使用Spark Streaming和Spark SQL进行数据处理, 并具有SPARK SQL优化经验；",
//                 "5、熟悉MySQL，Oracle等数据库的使用, 了解常见NO-SQL数据库；"
//  ,"6、有较强的逻辑思维能力，善于分析、归纳、快速定位并解决问题；"
// ,"7、具备快速学习能力、沟通协调能力及团队精神，有较强的责任心和学习积极性；"
// ,"8、有大数据平台产品建设经验者优先；"
// ,"9、有数据挖掘算法经验者优先。"
//              ]
//             }
//           }
        ]
      },
      {
        name:"数字孪生实验室",
        id:4,
        child:[
          {
            name:"java开发工程师",
            workExp:"2年以上",
            id:301,
            data:{
              education:"本科以上" ,//学历
              workExp:"2年以上",
              salary:"8-13k",
              duty:[
                "1、根据项目具体要求，承担后端开发任务，按计划完成任务目标；",
                "2、参与需求分析、系统设计，并负责完成系统的软件的程序设计与模块代码编写；",
                "3、有关技术方案、文档的编写，软件单元的测试；",
                "4、负责编制与项目相关的技术文档；"
 ,
                "5、协助测试人员完成软件系统及模块的测试。"             ],
              requirement:[
                "1、2年以上Java开发经验，Java基础扎实，熟悉Java响应式编程；",
                "2、了解Java开源框架，如spring,Hibernate等，熟悉Tomcat、Jetty等开源服务器；",
                "3、有一定的前端基础，熟悉Linux下的常用命令；",
                "4.、熟练掌握MySQL，对Nosql存储技术有一定的了解；",
                "5、具有良好的沟通能力，对技术有激情，喜欢钻研，能快速接受和掌握新技术，有较强的独立、主动的学习能力。"
              ]
            }
          },
          {
            name:"前端开发工程师",
            workExp:"2年以上",
            id:303,
            data:{
              education:"本科以上" ,//学历
              workExp:"2年以上",
              salary:"9-15k",
              duty:[
                "1、负责前端产品的技术研发，确保符合规范的前端代码规范；",
                "2、负责公司现有项目和新项目的前端修改调试和开发工作；",
                "3、与设计团队紧密配合，能够实现设计师的设计想法；",
                "4、与后端开发团队紧密配合，确保代码有效对接，优化Web系统前端性能；",
                "5、参与进行关键技术验证以及技术选型工作；",
                "6、和产品经理沟通并确定产品开发需求。"],
              requirement:[
                "1、本科及以上学历，计算机相关专业；",
                "2、两年以上Web前端开发经验，成功开发过中大型Web应用程序，良好的UI交互实现能力；",
                "3、精通HTML5、CSS3、Javascript等，具备前端架构能力，熟悉使用 Webpack、Gulp 等前端工程化、模块化工具；",
                "4、至少精通Vue、React或Angular等前端框架的一种，掌握其原理；",
                "5、具备HTML5编辑器、富文本编辑器开发经验优先，熟悉Canvas，良好的代码能力、沟通合作能力，掌握常用的算法、设计模式；"
 ,
"6、熟悉各种浏览器平台的特性，能够很好地解决兼容问题；"
 ,
"7、善于学习及了解新技术。"
            ]
            }
          },
          {
            name:"研究助理",
            workExp:"经验不限（本科）",
            id:401,
            data:{
              education:"本科及以上" ,//学历
              workExp:"经验不限（本科）",
              salary:"5-8k",
              duty:[
                "1、熟练使用办公软件和PPT制作；",
                "2、精通python和java；",
                "3、熟悉商业计划书和产品需求方案撰写；",
                "4、物联网的上下游厂商对接。"
              ],
              requirement:[
                "1、本科及以上学历；",
                "2、毕业论文与物联网相关；",
                "3、熟悉智慧城市、物联网产品的设计理念及方法，了解数据可视化技术特性和系统构架；",
                "4、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
  "5、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；"
,
                "6、有参加大赛和产品设计与开发工作经验者优先。"
         ]
            }
          },
          {
            name:"UE4开发工程师",
            workExp:"2年以上",
            id:402,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"13-16k",
              duty:[
                "1、负责研究产品发展方向，参与制定产品发展策略，提升用户体验；",
                "2、负责挖掘和把握企业客户各层次需求；",
                "3、负责产品的前期调研、规划和设计（包括功能定位、框架设计和交互设计）、对产品进行持续的优化和改进；",
                "4、负责产品开发项目的周期管理和进度把控，跨部门协调和沟通，推动UI、开发、测试、运营等人员紧密合作达成产品目标；"
 ,
                "5、产品生命周期管理，不断优化，完成产品迭代。"
             ],
              requirement:[
                "1、本科及以上学历，2年以上UE4工作经验；",
                "2、精通UE4引擎，可撰写UE4引擎技术文档，并与UI配合将项目资源导入引擎；",
                "3、熟悉UE4渲染管线原理，可进行客户端效率问题的优化；",
                "4、熟练使用UE4蓝图、C++及插件技术撰写客户端代码等；",
                "5、熟悉建模软件、GIS数据使用，如MAX、CAD、迈高图、ArcGIS等软件；"
,
                "6、熟悉智慧城市、物联网产品的设计理念及方法，对用户习性有独到认识，了解数据可视化技术特性和系统构架；",
                "7、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
                "8、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；",
                "9、具有较强的项目管理能力，良好的团队交流和协作能力，有责任心，善于跨部门组织、沟通和协调资源；",
                "10、有产品设计与开发工作经验者优先。"              ]
            }
          },
          {
            name:"项目经理",
            workExp:"2年以上",
            id:403,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"8-16k",
              duty:[
           "1、负责研究产品发展方向，参与制定产品发展策略，提升用户体验；",
                "2、负责挖掘和把握企业客户各层次需求；",
                "3、负责产品的前期调研、规划和设计，设计包括功能定位、框架设计和交互设计，对产品进行持续的优化和改进；"
, "4、负责产品开发项目的周期和进度把控，跨部门协调和沟通，推动UI、开发、测试、运营等人员紧密合作达成产品目标；"
 
, "5、产品生命周期管理，不断优化，完成产品迭代。" ],
              requirement:[
                "1、本科及以上学历， 2年以上移动互联网工作经验；",
                "2、熟悉智慧城市、物联网产品的设计理念及方法，对用户习性有独到认识，了解技术特性和系统构架；",
                "3、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；",
                "4、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
                "5、较强的项目管理能力，善于跨部门组织、沟通和协调资源；"
 ,
                "6、精通产品原型设计工具，如Axure、Visio、墨刀、思维导图等软件；"
  ,
                "7、有产品设计与开发工作经验者优先。"
            ]
            }
          }
        ]
      },
     {
        name:"智能驾驶与大数据实验室",
        id:5,
        child:[
          {
            name:"研究助理",
            workExp:"经验不限（本科）",
            id:501,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（本科）",
              salary:"8-10k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、本科生需具有良好的C语言或C++编程能力；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",
                "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；",
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
             ]},
          },
          {
            name:"助理研究员",
            workExp:"经验不限（硕士）",
            id:502,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（硕士）",
              salary:"20-22k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、硕士生需具有数据标注、仿真系统开发等相关技术经验；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",
                "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；",
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
             ]}
            },{
            name:"副研究员",
            workExp:"经验不限（博士）",
            id:503,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（博士）",
              salary:"32-38k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、 博士生需熟悉智能驾驶和数据集相关技术；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",      "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；"
,
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
              ]
            }          }
        ]
      },
    ]
  },
  "en":{
    data:[
      {
        name:"科研部",
        id:1,
        child:[
          {
            name:"科研部副总监",
            workExp:"3-5年",
            id:101,
            data:{
              education:"硕士及以上" ,//学历
              workExp:"3-5年",
              salary:"20-35k",
              duty:[
                "1、组织收集、分析与研究院相关的政策文件及最新政策动态，选择适合申报的各类产品的项目申报信息；组织申请研究院各类扶持资金，包括政府支持专项资金、创新资金、科研资金；",
                "2、组织并负责对申报项目进行可行性分析、推进意见及前期准备；协助部门领导解决项目申报中需要与政府部门沟通及协调事项；",
                "3、维护研究院横向/纵向课题相关合作单位长期稳定合作关系，拓展科研合作资源。"],
              requirement:[
                "1、3-5年工作经历；",
                "2、硕士（含）以上学历，工科类专业优先；",
                "3、2年以上科研项目申报和组织管理工作经验，具有高校和科研院所工作经历优先；",
                "4、较强的组织协调能力与执行能力；",
                "5、具有良好团队合作精神和内部组织管理能力。"
              ]
            }
          },
          {
            name:"大数据研究员",
            workExp:"2年以上",
            id:102,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"13-18k",
              duty:[
                "1、负责新兴大数据技术的理论方法、核心技术及应用技术的研究，并形成相关研究报告；",
                "2、针对不同的科研业务需求，形成面向政府/行业的大数据解决方案；",
                "3、负责大数据相关技术规划、标准研究；",
                "4、负责大数据相关课题申报及研究工作。"
              ],
              requirement:[
                "1、计算机、数学相关专业，全日制本科及以上学历；",
                "2、2年以上工作经验；",
                "3、具有较强的数据挖掘、机器学习、语义分析的理论基础和实际项目经验，精通数据分析与各种算法与模型；构建用户画像分析体系；",
                "4、精通Hadoop／Spark、Hive、HBase等主流的大数据技术，有产品／平台项目研发经验者优先；具备大型复杂Hadoop数据平台的建设实施经验；精通Java及Python。"
              ]
            }
          },
//           {
//             name:"项目经理",
//             workExp:"1年以上",
//             id:103,
//             data:{
//               education:"本科以上" ,//学历
//               workExp:"1年以上",
//               salary:"20-30k",
//               duty:[
//                 "1、组织申请研究院各类扶持资金，包括政府支持专项资金、创新资金、科研资金、奖励资金、资质申请、资源申请、知识产权的申请与保护、人才资质等所有项目的申请和文件编制的工作； ",
//                 "2、负责收集、分析与研究院相关的政策文件及最新政策动态，选择适合申报的各类产品的项目申报信息；",
//                 "3、规划研究院全年项目申报计划、对申报项目进行可行性分析、推进意见及前期准备；",
//                 "4、协调研究院内部相关部门准备和收集文档资料，参与编制、撰写、修改、整理申报材料；"
//  ,
//                 "5、整理项目申报、批复文件等相关数据，文档数据录入，项目维护和实施网上申报等；",
//                 "6、组织协调并整合研究院资源，参与项目的立项、申报、审批、验收等各环节工作，负责申报材料的送审、公关执行、过程跟踪，直至项目验收完成；",
//                 "7、按照国家、省、市级、区科技局相关文件要求撰写材料，协助部门领导解决项目申报中需要与政府部门沟通及协调事项；",
//                 "8、负责组织软件著作权、专利、高新技术企业、质量管理体系等企业知识产权相关文件的撰写和申报、验收等工作；",
//                 "9、建立和维护与政府部门的长期稳定合作关系，为研究院争取有利资源。"             ],
//               requirement:[
//                 "1、计算机、数学、自动化、电子信息工程、新闻传媒等相关专业本科以上学历；",
//                 "2、责任心强，性格开朗，具有活动组织、学生会工作经历者优先；",
//                 "3、要有科研项目申报经验，主管负责过本单位的科研立项的工作经验1年以上；",
//                 "4、具有较好的语言沟通能力与团队合作精神，具有极强的学习能力、写作能力；",
//                 "5、具有互联网、通信行业研发和工作经验，有相关科研项目申报经验优先。"
//               ]
//             }
//           }
        ]
      },
      {
        name:"综合部",
        id:2,
        child:[
          {
            name:"人力资源高级经理",
            workExp:"8年以上",
            id:201,
            data:{
              education:"硕士及以上" ,//学历
              workExp:"8年以上",
              salary:"13-18k",
              duty:[
                "1、负责人力资源部整体管理，组织达成相关工作目标；",
                "2、根据研究院总体发展战略目标，制订研究院人力资源战略发展规划；",
                "3、主导研究院组织架构及岗位设计、评价及完善工作，组织各岗位工作分析和人员定岗定编；",
                "4、主导组织建立和完善研究院的人力资源管控体系；",
                "5、主导研究院年度的培训计划的审定与控制，对培训预算，培训计划的落实进行日常的监督与管理；","6、主导制定和修订研究院各项绩效考核制度、先进评选方案，并督导相关人员执行；","7、主导制定和修订研究院薪酬福利制度、设计薪酬体系、编制薪资方案及福利计划，并督导相关人员执行；","8、向研究院高层决策者提供有关人力资源战略、组织建设等方面的建议，并致力于提高研究院的人力管理水平。"
              ],
              requirement:[
                "知识与经验要求",
                "1、全日制大学硕士及以上学历，人力资源及管理类专业优先；",
                "2、8年以上人力资源管理经验，3年以上人力资源高级经理或总监团队管理经验；",
                "3、了解现代企业人力资源管理模式和实践经验积累，对人力资源管理各个职能模块均有较深入的认识；",
                "4、熟悉国家相关的政策、法律法规。",
                "综合素质要求",
 "1、积极进取，具备很强的责任心、上进心和事业心；","2、富有热情，坚韧不拔，抗压力强；","3、具有良好的职业道德，能摒弃个人私利和偏见，依据原则、标准和事实看待和处理人和事；","4、具备良好的人际交往能力、组织协调能力、沟通能力以及解决复杂问题的能力。"           ]
            }
          }
        ]
      },
      {
        name:"业务部",
        id:3,
        child:[
          {
            name:"技术经理",
            workExp:"5年以上",
            id:302,
            data:{
              education:"本科以上" ,//学历
              workExp:"5年以上",
              salary:"15-25k",
              duty:[
                "1、根据项目具体要求，承担技术管理角色，按计划完成任务目标；",
                "2、参与需求分析、系统设计，并负责完成系统的技术架构设计与核心模块代码编写工作；",
                "3、有关技术方案、文档的编写，研发管理规范的制定与落地执行工作；",
                "4、负责搭建和维护核心IT资源和硬件等。"
              ],
              requirement:[
                "1、5年以上Java开发经验，2年以上大型系统技术架构经验，2年以上项目管理经验；",
                "2、熟悉Java开源框架，如SpringBoot、微服务应用等，熟悉J2EE规范，熟悉Tomcat、Jetty等开源服务器；",
                "3、具体一定的网络、服务器管理经验，熟悉Linux下的常用命令，熟练掌握网络基础架构知识，了解各种网络协议及其原理应用，有一定的网络架构应用经验优先；",
                "4、熟悉服务器虚拟化技术、分布式存储架构技术，有一定的虚拟化、集群架构应用经验；",
                "5、熟练掌握MySQL、Nosql等数据库相关的技术，有海量大数据应用架构经验者优先；"
 ,  "6、熟悉常用设计模式、设计工具，熟悉高并发、高负载、高可用性系统设计的设计开发及调优；"
 ,"7、具有良好的沟通能力，对技术有激情，喜欢钻研，能快速接受和掌握新技术，有较强的独立、主动的学习能力。"
            ]
            }
          },
          {
            name:"算法工程师",
            workExp:"2年以上",
            id:304,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"16-20k",
              duty:[
                "1、负责相关数据业务分析、大数据分析和数据挖掘；",
                "2、负责大数据的处理、整合及数据建模，协同业务开发人员，将模型算法成果应用到实际业务系统中，并通过可视化工具进行分析成果展示；",
                "3、负责根据实际业务要求，完成较深入的专项数据分析并形成分析报告；",
                "4、负责大数据模型、业务的相关算法的研究及应用；"
 ,
                "5、负责在客户现场进行需求调研，收集分析资料。"
              ],
              requirement:[
                "1、本科及以上学历，计算机、大数据、数据挖掘、机器学习、统计、数学等相关专业；",
                "2、具备良好的数学，统计学基础，对数据敏感，逻辑性强；",
                "3、具备良好的沟通能力，有工作激情、团队协作精神，可以承受较强的工作压力；",
                "4、熟练使用一种以上数据分析建模软件( 如Python、R、MATLAB等），有计算机相关专业基础；",
                "5、具有海量数据挖掘及分析相关项目经验，具有互联网行业、政府行业分析挖掘经验、文本挖掘经验优先，了解运营商数据优先；"
 ,
                "6、2年及以上工作经历，有电信运营商、政府及其他相关大数据项目工作经历优先。"
             ]
            }
          },
          {
            name:"大数据开发工程师",
            workExp:"2年以上",
            id:305,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"10-20k",
              duty:[
                "1、开展基于海量大数据分析处理挖掘工作；",
                "2、承担大数据需求问题的优化/规划设计工作，参与大数据算法研究、数据分析和应用开发等工作；",
                "3、对基于需求问题的分析、设计、实现能够提出独到的见解和思考；能够基于问题提出对应的解决模型（算法）；",
                "4、参与相关产品线与项目的实施工作。"
              ],
              requirement:[
                "1、计算机类相关专业，本科及以上学历，硕士/博士学历优先；",
                "2、具有2年以上大数据应用领域内工作经验者优先；",
                "3、具备较强的开发能力，熟悉Java/Python等数据分析语言及相关库应用者；",
                "4、熟悉MySQL/Hive等数据库，有大数据开发经验，熟悉信息采集与数据分析经验者优先；"
,
                "5、工作主动、有计划，具有良好的沟通理解能力，良好的团队合作精神和保密意识；"
 
,
                "6、具备良好的抗压能力，对技术和业务难题富有钻研精神。"
               ]
            }
          },
//           {
//             name:"大数据分析师",
//             workExp:"2年以上",
//             id:306,
//             data:{
//               education:"硕本科及以上" ,//学历
//               workExp:"2年以上",
//               salary:"9-15k",
//               duty:[
//                 "1、参与研究院大数据产品规划,大数据处理分析平台的设计；",
//                 "2、参与设计数据系统的数据层，根据业务需求进行数据报表相关的研发工作；",
//                 "3、负责数据分析、加工、清理、处理程序的开发；",
//                 "4、负责基于Hadoop/Spark/Hive/Kafka等分布式计算平台实现离线分析、实时分析的应用开发；",
//                 "5、负责数据架构设计及前端数据应用开发工作；",
//                 "6、负责大数据的处理和分析工作、大数据平台展现层的研发工作。"            ],
//               requirement:[
//                 "1、大学本科以上学历，2年以上大数据开发经验；",
//                 "2、熟悉Java、Scala、Python语言、熟悉常用设计模式、具有代码重构意识；",
//                 "3、熟练使用Hadoop、Hbase、Kafka、Hive、Spark、Presto、Kylin、Flink,熟悉底层框架和实现原理；",
//                 "4、使用Spark Streaming和Spark SQL进行数据处理, 并具有SPARK SQL优化经验；",
//                 "5、熟悉MySQL，Oracle等数据库的使用, 了解常见NO-SQL数据库；"
//  ,"6、有较强的逻辑思维能力，善于分析、归纳、快速定位并解决问题；"
// ,"7、具备快速学习能力、沟通协调能力及团队精神，有较强的责任心和学习积极性；"
// ,"8、有大数据平台产品建设经验者优先；"
// ,"9、有数据挖掘算法经验者优先。"
//              ]
//             }
//           }
        ]
      },
      {
        name:"数字孪生实验室",
        id:4,
        child:[
          {
            name:"java开发工程师",
            workExp:"2年以上",
            id:301,
            data:{
              education:"本科以上" ,//学历
              workExp:"2年以上",
              salary:"8-13k",
              duty:[
                "1、根据项目具体要求，承担后端开发任务，按计划完成任务目标；",
                "2、参与需求分析、系统设计，并负责完成系统的软件的程序设计与模块代码编写；",
                "3、有关技术方案、文档的编写，软件单元的测试；",
                "4、负责编制与项目相关的技术文档；"
 ,
                "5、协助测试人员完成软件系统及模块的测试。"             ],
              requirement:[
                "1、2年以上Java开发经验，Java基础扎实，熟悉Java响应式编程；",
                "2、了解Java开源框架，如spring,Hibernate等，熟悉Tomcat、Jetty等开源服务器；",
                "3、有一定的前端基础，熟悉Linux下的常用命令；",
                "4.、熟练掌握MySQL，对Nosql存储技术有一定的了解；",
                "5、具有良好的沟通能力，对技术有激情，喜欢钻研，能快速接受和掌握新技术，有较强的独立、主动的学习能力。"
              ]
            }
          },
          {
            name:"前端开发工程师",
            workExp:"2年以上",
            id:303,
            data:{
              education:"本科以上" ,//学历
              workExp:"2年以上",
              salary:"9-15k",
              duty:[
                "1、负责前端产品的技术研发，确保符合规范的前端代码规范；",
                "2、负责公司现有项目和新项目的前端修改调试和开发工作；",
                "3、与设计团队紧密配合，能够实现设计师的设计想法；",
                "4、与后端开发团队紧密配合，确保代码有效对接，优化Web系统前端性能；",
                "5、参与进行关键技术验证以及技术选型工作；",
                "6、和产品经理沟通并确定产品开发需求。"],
              requirement:[
                "1、本科及以上学历，计算机相关专业；",
                "2、两年以上Web前端开发经验，成功开发过中大型Web应用程序，良好的UI交互实现能力；",
                "3、精通HTML5、CSS3、Javascript等，具备前端架构能力，熟悉使用 Webpack、Gulp 等前端工程化、模块化工具；",
                "4、至少精通Vue、React或Angular等前端框架的一种，掌握其原理；",
                "5、具备HTML5编辑器、富文本编辑器开发经验优先，熟悉Canvas，良好的代码能力、沟通合作能力，掌握常用的算法、设计模式；"
 ,
"6、熟悉各种浏览器平台的特性，能够很好地解决兼容问题；"
 ,
"7、善于学习及了解新技术。"
            ]
            }
          },
          {
            name:"研究助理",
            workExp:"经验不限（本科）",
            id:401,
            data:{
              education:"本科及以上" ,//学历
              workExp:"经验不限（本科）",
              salary:"5-8k",
              duty:[
                "1、熟练使用办公软件和PPT制作；",
                "2、精通python和java；",
                "3、熟悉商业计划书和产品需求方案撰写；",
                "4、物联网的上下游厂商对接。"
              ],
              requirement:[
                "1、本科及以上学历；",
                "2、毕业论文与物联网相关；",
                "3、熟悉智慧城市、物联网产品的设计理念及方法，了解数据可视化技术特性和系统构架；",
                "4、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
  "5、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；"
,
                "6、有参加大赛和产品设计与开发工作经验者优先。"
         ]
            }
          },
          {
            name:"UE4开发工程师",
            workExp:"2年以上",
            id:402,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"13-16k",
              duty:[
                "1、负责研究产品发展方向，参与制定产品发展策略，提升用户体验；",
                "2、负责挖掘和把握企业客户各层次需求；",
                "3、负责产品的前期调研、规划和设计（包括功能定位、框架设计和交互设计）、对产品进行持续的优化和改进；",
                "4、负责产品开发项目的周期管理和进度把控，跨部门协调和沟通，推动UI、开发、测试、运营等人员紧密合作达成产品目标；"
 ,
                "5、产品生命周期管理，不断优化，完成产品迭代。"
             ],
              requirement:[
                "1、本科及以上学历，2年以上UE4工作经验；",
                "2、精通UE4引擎，可撰写UE4引擎技术文档，并与UI配合将项目资源导入引擎；",
                "3、熟悉UE4渲染管线原理，可进行客户端效率问题的优化；",
                "4、熟练使用UE4蓝图、C++及插件技术撰写客户端代码等；",
                "5、熟悉建模软件、GIS数据使用，如MAX、CAD、迈高图、ArcGIS等软件；"
,
                "6、熟悉智慧城市、物联网产品的设计理念及方法，对用户习性有独到认识，了解数据可视化技术特性和系统构架；",
                "7、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
                "8、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；",
                "9、具有较强的项目管理能力，良好的团队交流和协作能力，有责任心，善于跨部门组织、沟通和协调资源；",
                "10、有产品设计与开发工作经验者优先。"              ]
            }
          },
          {
            name:"项目经理",
            workExp:"2年以上",
            id:403,
            data:{
              education:"本科及以上" ,//学历
              workExp:"2年以上",
              salary:"8-16k",
              duty:[
           "1、负责研究产品发展方向，参与制定产品发展策略，提升用户体验；",
                "2、负责挖掘和把握企业客户各层次需求；",
                "3、负责产品的前期调研、规划和设计，设计包括功能定位、框架设计和交互设计，对产品进行持续的优化和改进；"
, "4、负责产品开发项目的周期和进度把控，跨部门协调和沟通，推动UI、开发、测试、运营等人员紧密合作达成产品目标；"
 
, "5、产品生命周期管理，不断优化，完成产品迭代。" ],
              requirement:[
                "1、本科及以上学历， 2年以上移动互联网工作经验；",
                "2、熟悉智慧城市、物联网产品的设计理念及方法，对用户习性有独到认识，了解技术特性和系统构架；",
                "3、具备独立撰写产品文档的能力，熟练掌握产品需求分析、设计技巧,对交互设计过程有深入了解，有成功的产品策划案例；",
                "4、具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力；",
                "5、较强的项目管理能力，善于跨部门组织、沟通和协调资源；"
 ,
                "6、精通产品原型设计工具，如Axure、Visio、墨刀、思维导图等软件；"
  ,
                "7、有产品设计与开发工作经验者优先。"
            ]
            }
          }
        ]
      },
     {
        name:"智能驾驶与大数据实验室",
        id:5,
        child:[
          {
            name:"研究助理",
            workExp:"经验不限（本科）",
            id:501,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（本科）",
              salary:"8-10k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、本科生需具有良好的C语言或C++编程能力；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",
                "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；",
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
             ]},
          },
          {
            name:"助理研究员",
            workExp:"经验不限（硕士）",
            id:502,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（硕士）",
              salary:"20-22k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、硕士生需具有数据标注、仿真系统开发等相关技术经验；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",
                "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；",
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
             ]}
            },{
            name:"副研究员",
            workExp:"经验不限（博士）",
            id:503,
            data:{
              education:"本科" ,//学历
              workExp:"经验不限（博士）",
              salary:"32-38k",
              duty:[
                "1、参与智能驾驶数据集建设项目（国家级）；",
                "2、撰写科研项目申请报告；",
                "3、发表高质量论文和申报发明专利。" ],
              requirement:[
                "1、计算机、自动化、机械工程、电气工程等相关学科的优秀毕业生；",
                "2、具有良好的英文阅读能力（通过CET-6）；",
                "3、 博士生需熟悉智能驾驶和数据集相关技术；",
                "4、具有良好的学习能力、沟通能力和团队合作精神；",      "5、具有扎实的相关学科基础，能独立开展具体的/不同的科研任务；"
,
                "6、具有良好的学术道德、沟通能力和团队合作精神。"
              ]
            }          }
        ]
      },
    ]
  }
};

//页脚内容
export const footerData = {
  "zh-CN":{
    contact:[
      "T +86 0756 6348393",
      "L 珠海市香洲区港湾一号湾11栋五层",
      "E wisdom@chiefdata.org",
      "W www.chiefdata.org.cn"
    ],
    copyright: "<span style=\"display:inline-block;\">Copyright © 2018 All Rights Reserved | </span><a target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496720\" style=\"display:inline-block;margin: 0px 0px 0px 5px;vertical-align: middle;text-decoration:none;height:20px;line-height:20px;\"><img src=\""+require('./assets/img/beian.png')+"\" style=\"float:left;\"/><p style=\"float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;color:#939393;\">粤公网安备 44049102496720号</p></a>"
  },
  "en":{
    contact:[
      "T +86 0756 6348393",
      "L 5F, Bldg Wan 11, Tech Bay, High Tech Industrial Development District, Zhuhai",
      "E wisdom@chiefdata.org",
      "W www.chiefdata.org.cn"
    ],
    copyright: "<span style=\"display:inline-block;\">Copyright © 2018 All Rights Reserved | </span><a target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496720\" style=\"display:inline-block;margin: 0px 0px 0px 5px;vertical-align: middle;text-decoration:none;height:20px;line-height:20px;\"><img src=\""+require('./assets/img/beian.png')+"\" style=\"float:left;\"/><p style=\"float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;color:#939393;\">粤公网安备 44049102496720号</p></a>"
  }
};
